import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

const UpsellContent = ({ onCancel, productName }) => {
  const currentUrl =  `${window.location.protocol}//${window.location.host}`;
  const offerLink = `${currentUrl}/offers/one-book-way`;

  const { funnelCode } = useParams();
  const addFacebookPixelScript =
    funnelCode.startsWith('trustOffer') || funnelCode.startsWith('listingPresentation');
  return (
    <>
      <Helmet>
        <title>Are you up for the Challenge?</title>
        <link rel="stylesheet" media="screen" href="/lander.css" />
        <meta name="description" content="Nested component" />
        <script src="//fast.wistia.com/assets/external/E-v1.js" async="" />
        <style type="text/css">
          {`
            .ant-layout {
              background: none!important;
          }
            #section--72740 {
              max-width: 100%;
            }
            .elBTN a:hover {
                opacity: .8;
            }

            .perks {
                list-style-image: url('//go.authorify.com/hosted/images/8a/93f256e8a24d70ae6c89219116c627/List.png');
                font-size: 30px;
            }

            .price {
                font-weight: bold;
                color: #ac132a;
            }

            .bonus {
                font-weight: bold;
                color: #ffffff;
                background-color: #ac132a;
            }
          `}
        </style>

        {addFacebookPixelScript && (
          <script>
            {`!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '716384701741346');
            fbq('track', 'PageView');
            `}
          </script>
        )}
        {addFacebookPixelScript && (
          <noscript>
            {`<img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=716384701741346&ev=PageView&noscript=1"
            />`}
          </noscript>
        )}
      </Helmet>
      <div className="containerWrapper">
        <div
          className="fullContainer noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 shadow0 bgCover101 emptySection"
          id="container-10146"
          data-title="Section"
          data-block-color="0074C7"
          style={{
            paddingTop: 30,
            paddingBottom: 30,
            outline: 'none',
            backgroundImage:
              'url("//go.authorify.com/hosted/images/2d/b2078d5ce44c5eb03e73b851114287/header-bg.jpg")',
            backgroundColor: 'rgba(78, 66, 66, 0)',
          }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable">
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-126"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="3 column row"
              style={{ paddingTop: 0, paddingBottom: 0, margin: 0, outline: 'none' }}
              data-hide-on="desktop"
            >
              <div
                id="col-left-168-139"
                className="col-md-4 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elMargin0 elAlign_left ui-droppable de-editable"
                    id="tmp_image-63822-173"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/6c/f7ad63bab5435eae0e8378a26a9954/One-Book-Away.png"
                      className="elIMG ximg"
                      alt=""
                      width={150}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-center-104-138"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="center"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                />
              </div>
              <div
                id="col-right-172-101"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="3rd Column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                />
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-183"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="3 column row - Clone"
              style={{ paddingTop: 0, paddingBottom: 0, margin: 0, outline: 'none' }}
              data-hide-on="mobile"
            >
              <div
                id="col-left-168-163-185"
                className="col-md-4 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elMargin0 elAlign_left ui-droppable de-editable"
                    id="tmp_image-63822-162-137"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/6c/f7ad63bab5435eae0e8378a26a9954/One-Book-Away.png"
                      className="elIMG ximg"
                      alt=""
                      width={150}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-172-137-159"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="3rd Column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                />
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-185"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-141-122"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-47377-140"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'center',
                        fontSize: 46,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Stop! I Have A Special Offer for You!</b>
                      <div>
                        <b>
                          I Want To Personally Help You Get 4-6 New Listings A Month
                        </b>
                      </div>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-93539"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      style={{
                        textAlign: 'center',
                        fontSize: 23,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      So,{' '}
                      <b>
                        I’m going to give you over $4,089.50 worth of my best Listing Tools and
                        Training
                      </b>{' '}
                      for almost Free. Scroll down to discover everything you’re going to get with
                      this special offer.
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-164"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{ padding: '20px 0px', margin: 0, outline: 'none' }}
            >
              <div
                id="col-left-103-117"
                className="innerContent col_left ui-resizable col-md-7"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elVideoWrapper de-video-block elVideoWidth100 elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_video-82829-179"
                    data-de-type="video"
                    data-de-editing="false"
                    data-title="video"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-video-type="custom"
                    style={{ outline: 'none', cursor: 'pointer' }}
                    data-wistia-url="https://smart-agents.wistia.com/medias/zhui3b8w5h"
                    data-wistia-autoplay="yes"
                    data-element-theme="customized"
                    aria-disabled="false"
                  >
                    <div className="elVideoplaceholder">
                      <div className="elVideoplaceholder_inner" />
                    </div>
                    <div className="elVideo" style={{ display: 'none' }}>
                      <div
                        className="wistia_responsive_padding"
                        style={{ padding: '56.25% 0 0 0', position: 'relative' }}
                      >
                        <div
                          className="wistia_responsive_wrapper"
                          style={{
                            height: '100%',
                            left: 0,
                            position: 'absolute',
                            top: 0,
                            width: '100%',
                          }}
                        >
                          <div
                            className="wistia_video_foam_dummy"
                            data-source-container-id="wistia-kd99tdseca-1"
                            style={{
                              border: 0,
                              display: 'block',
                              height: 0,
                              margin: 0,
                              padding: 0,
                              position: 'static',
                              visibility: 'hidden',
                              width: 'auto',
                            }}
                          />
                          <div
                            className="wistia_embed wistia_async_kd99tdseca videoFoam=true wistia_embed_initialized"
                            style={{
                              height: '355.781px',
                              position: 'relative',
                              width: '632.5px',
                            }}
                            id="wistia-kd99tdseca-1"
                          >
                            <div
                              className="wistia_swatch"
                              style={{
                                height: '100%',
                                left: 0,
                                opacity: 1,
                                overflow: 'hidden',
                                position: 'absolute',
                                top: 0,
                                transition: 'opacity 200ms ease 0s',
                                width: '100%',
                              }}
                            >
                              <img
                                src="https://fast.wistia.com/embed/medias/kd99tdseca/swatch"
                                style={{
                                  filter: 'blur(5px)',
                                  height: '100%',
                                  objectFit: 'contain',
                                  width: '100%',
                                }}
                                alt=""
                                aria-hidden="true"
                                onLoad="this.parentNode.style.opacity=1;"
                              />
                            </div>
                            <div
                              id="wistia_chrome_37"
                              className="w-chrome"
                              style={{
                                display: 'inline-block',
                                height: '355.781px',
                                lineHeight: 'normal',
                                margin: 0,
                                padding: 0,
                                position: 'relative',
                                verticalAlign: 'top',
                                width: '632.5px',
                                outline: 'none',
                                overflow: 'hidden',
                                boxSizing: 'content-box',
                              }}
                              tabIndex={-1}
                            >
                              <div
                                id="wistia_grid_57_wrapper"
                                style={{
                                  display: 'block',
                                  width: '632.5px',
                                  height: '355.781px',
                                }}
                              >
                                <div
                                  id="wistia_grid_57_above"
                                  style={{ height: 0, fontSize: 0, lineHeight: 0 }}
                                >
                                  {' '}
                                </div>
                                <div
                                  id="wistia_grid_57_main"
                                  style={{
                                    width: '632.5px',
                                    left: 0,
                                    height: '355.783px',
                                    marginTop: 0,
                                  }}
                                >
                                  <div id="wistia_grid_57_behind" />
                                  <div
                                    id="wistia_grid_57_center"
                                    style={{ width: '100%', height: '100%' }}
                                  >
                                    <div
                                      className="w-video-wrapper w-css-reset"
                                      style={{
                                        height: '100%',
                                        position: 'absolute',
                                        top: 0,
                                        width: '100%',
                                        opacity: 1,
                                        backgroundColor: 'rgb(0, 0, 0)',
                                      }}
                                    >
                                      <video
                                        id="wistia_simple_video_128"
                                        crossOrigin="anonymous"
                                        style={{
                                          background: 'transparent',
                                          display: 'block',
                                          height: '100%',
                                          maxHeight: 'none',
                                          maxWidth: 'none',
                                          position: 'static',
                                          visibility: 'visible',
                                          width: '100%',
                                          objectFit: 'fill',
                                        }}
                                        poster="https://fast.wistia.com/assets/images/blank.gif"
                                        aria-label="Video"
                                        src="blob:https://go.authorify.com/bcc01805-df74-481d-87a0-678d4a4d9bc5"
                                        controlsList="nodownload"
                                        playsInline=""
                                        preload="metadata"
                                        type="video/m3u8"
                                        x-webkit-airplay="allow"
                                      />
                                    </div>
                                    <div
                                      className="w-ui-container"
                                      style={{
                                        height: '100%',
                                        left: 0,
                                        position: 'absolute',
                                        top: 0,
                                        width: '100%',
                                        opacity: 1,
                                      }}
                                    >
                                      <div
                                        className="w-vulcan-v2 w-css-reset"
                                        id="w-vulcan-v2-56"
                                        style={{
                                          boxSizing: 'border-box',
                                          cursor: 'default',
                                          direction: 'ltr',
                                          height: '100%',
                                          left: 0,
                                          position: 'absolute',
                                          visibility: 'visible',
                                          top: 0,
                                          width: '100%',
                                        }}
                                      >
                                        <div
                                          className="w-vulcan--background w-css-reset"
                                          style={{
                                            height: '100%',
                                            left: 0,
                                            position: 'absolute',
                                            top: 0,
                                            width: '100%',
                                          }}
                                        >
                                          <div className="w-css-reset" data-handle="statusBar" />
                                          <div
                                            className="w-css-reset"
                                            data-handle="backgroundFocus"
                                          >
                                            <button
                                              aria-label="Play Video"
                                              className="w-css-reset w-vulcan-v2-button"
                                              style={{
                                                width: 0,
                                                height: 0,
                                                pointerEvents: 'none',
                                              }}
                                              tabIndex={0}
                                            />
                                          </div>
                                          <div
                                            className="w-css-reset"
                                            data-handle="videoThumbnail"
                                            style={{
                                              height: '100%',
                                              left: 0,
                                              position: 'absolute',
                                              top: 0,
                                              width: '100%',
                                              display: 'block',
                                            }}
                                          >
                                            <div
                                              style={{
                                                height: '100%',
                                                left: 0,
                                                position: 'absolute',
                                                top: 0,
                                                width: '100%',
                                              }}
                                            >
                                              <video
                                                id="wistia_simple_video_90"
                                                crossOrigin="anonymous"
                                                style={{
                                                  background: 'transparent',
                                                  display: 'block',
                                                  height: '100%',
                                                  maxHeight: 'none',
                                                  maxWidth: 'none',
                                                  position: 'static',
                                                  visibility: 'inherit',
                                                  width: '100%',
                                                  objectFit: 'fill',
                                                }}
                                                poster="https://fast.wistia.com/assets/images/blank.gif"
                                                aria-label="Video"
                                                src="blob:https://go.authorify.com/dad1034f-0874-4b5a-82e4-8cc2fade16cf"
                                                controlsList="nodownload"
                                                playsInline=""
                                                muted=""
                                                loop=""
                                                preload="metadata"
                                                type="video/m3u8"
                                              />
                                            </div>
                                            <div
                                              style={{
                                                height: '100%',
                                                left: 0,
                                                position: 'absolute',
                                                top: 0,
                                                width: '100%',
                                              }}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          aria-live="polite"
                                          className="w-vulcan--aria-live w-css-reset"
                                          aria-atomic="true"
                                          style={{
                                            position: 'absolute',
                                            left: '-99999em',
                                          }}
                                        />
                                        <div
                                          className="w-vulcan-overlays-table w-css-reset"
                                          style={{
                                            display: 'table',
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            width: '100%',
                                          }}
                                        >
                                          <div
                                            className="w-vulcan-overlays--left w-css-reset"
                                            style={{
                                              display: 'table-cell',
                                              verticalAlign: 'top',
                                              position: 'relative',
                                              width: 0,
                                            }}
                                          >
                                            <div
                                              style={{ height: '321.783px' }}
                                              className="w-css-reset"
                                            />
                                          </div>
                                          <div
                                            className="w-vulcan-overlays--center w-css-reset"
                                            style={{
                                              display: 'table-cell',
                                              verticalAlign: 'top',
                                              position: 'relative',
                                              width: '100%',
                                            }}
                                          >
                                            <div
                                              style={{ height: '321.783px' }}
                                              className="w-css-reset"
                                            >
                                              <div
                                                className="w-css-reset"
                                                style={{ pointerEvents: 'auto' }}
                                                data-handle="bigPlayButton"
                                              >
                                                <div
                                                  className="w-bpb-wrapper w-css-reset w-css-reset-tree"
                                                  style={{
                                                    display: 'block',
                                                    left: 'calc(50%)',
                                                    marginLeft: '-61.7676px',
                                                    marginTop: '-39.5313px',
                                                    position: 'absolute',
                                                    top: 'calc(50%)',
                                                  }}
                                                >
                                                  <button
                                                    className="w-big-play-button w-css-reset-button-important w-vulcan-v2-button"
                                                    style={{
                                                      cursor: 'pointer',
                                                      height: '79.0625px',
                                                      boxShadow: 'none',
                                                      width: '123.535px',
                                                    }}
                                                    aria-label="Play Video: One Book Away | 10.21.2021"
                                                    tabIndex={0}
                                                  >
                                                    <div
                                                      style={{
                                                        background: 'rgb(84, 187, 255)',
                                                        display: 'block',
                                                        left: 0,
                                                        height: '79.0625px',
                                                        mixBlendMode: 'darken',
                                                        position: 'absolute',
                                                        top: 0,
                                                        width: '123.535px',
                                                      }}
                                                    />
                                                    <div
                                                      style={{
                                                        backgroundColor: 'rgba(84, 187, 255, 0.7)',
                                                        height: '79.0625px',
                                                        left: 0,
                                                        position: 'absolute',
                                                        top: 0,
                                                        transition:
                                                          'background-color 150ms ease 0s',
                                                        width: '123.535px',
                                                      }}
                                                    />
                                                    <svg
                                                      x="0px"
                                                      y="0px"
                                                      viewBox="0 0 125 80"
                                                      enableBackground="new 0 0 125 80"
                                                      aria-hidden="true"
                                                      style={{
                                                        fill: 'rgb(255, 255, 255)',
                                                        height: '79.0625px',
                                                        left: 0,
                                                        strokeWidth: 0,
                                                        top: 0,
                                                        width: '100%',
                                                        position: 'absolute',
                                                      }}
                                                      alt=""
                                                    >
                                                      <rect
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        fill="none"
                                                        width={125}
                                                        height={80}
                                                      />
                                                      <polygon
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        fill="#FFFFFF"
                                                        points="53,22 53,58 79,40"
                                                      />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>
                                              <div
                                                className="w-css-reset"
                                                style={{ pointerEvents: 'auto' }}
                                                data-handle="clickForSoundButton"
                                              >
                                                <div
                                                  className="w-css-reset w-css-reset-tree"
                                                  data-handle="click-for-sound-backdrop"
                                                  style={{
                                                    display: 'block',
                                                    height: '100%',
                                                    left: 0,
                                                    pointerEvents: 'none',
                                                    position: 'absolute',
                                                    top: 0,
                                                    width: '100%',
                                                  }}
                                                >
                                                  <button
                                                    aria-label="Click for sound"
                                                    className="w-vulcan-v2-button click-for-sound-btn"
                                                    style={{
                                                      background: 'rgba(0, 0, 0, 0.8)',
                                                      border: '2px solid transparent',
                                                      borderRadius: 60,
                                                      cursor: 'pointer',
                                                      display: 'flex',
                                                      justifyContent: 'space-between',
                                                      alignItems: 'center',
                                                      outline: 'none',
                                                      pointerEvents: 'auto',
                                                      position: 'absolute',
                                                      right: '20.2363px',
                                                      top: '20.2363px',
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-end',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        maxWidth: 0,
                                                        transition: 'max-width 200ms ease 0s',
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          color: 'rgb(255, 255, 255)',
                                                          fontFamily:
                                                            'WistiaPlayerInter, Helvetica, sans-serif',
                                                          fontSize: 18,
                                                          fontWeight: 500,
                                                          paddingLeft: '1em',
                                                        }}
                                                      >
                                                        Click for sound
                                                      </span>
                                                    </div>
                                                    <svg
                                                      viewBox="0 0 237 237"
                                                      width="51.884765625"
                                                      height="51.884765625"
                                                    >
                                                      <style
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            '\n  @keyframes VOLUME_SMALL_WAVE_FLASH {\n    0% { opacity: 0; }\n    33% { opacity: 1; }\n    66% { opacity: 1; }\n    100% { opacity: 0; }\n  }\n\n  @keyframes VOLUME_LARGE_WAVE_FLASH {\n    0% { opacity: 0; }\n    33% { opacity: 1; }\n    66% { opacity: 1; }\n    100% { opacity: 0; }\n  }\n\n  .volume__small-wave {\n    animation: VOLUME_SMALL_WAVE_FLASH 2s infinite;\n    opacity: 0;\n  }\n\n  .volume__large-wave {\n    animation: VOLUME_LARGE_WAVE_FLASH 2s infinite .3s;\n    opacity: 0;\n  }\n',
                                                        }}
                                                      />
                                                      <path
                                                        fill="#fff"
                                                        d="M88 107H65v24h24l23 23V84z"
                                                      />
                                                      <g
                                                        fill="none"
                                                        stroke="#fff"
                                                        strokeLinecap="round"
                                                        strokeWidth={10}
                                                      >
                                                        <path
                                                          d="M142 86c9 21 9 44 0 65"
                                                          className="volume__small-wave"
                                                        />
                                                        <path
                                                          d="M165 74c13 23 13 66 0 89"
                                                          className="volume__large-wave"
                                                        />
                                                      </g>
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>
                                              <div
                                                className="w-css-reset"
                                                style={{ pointerEvents: 'auto' }}
                                                data-handle="playPauseNotifier"
                                              />
                                              <div
                                                className="w-css-reset"
                                                style={{ pointerEvents: 'auto' }}
                                                data-handle="playPauseLoading"
                                              >
                                                <div
                                                  className="w-css-reset w-css-reset-tree"
                                                  style={{
                                                    height: '100%',
                                                    left: 0,
                                                    pointerEvents: 'none',
                                                    position: 'absolute',
                                                    top: 0,
                                                    width: '100%',
                                                  }}
                                                >
                                                  <button
                                                    aria-label="Play Video"
                                                    className="w-vulcan-v2-button"
                                                    style={{
                                                      background: 'rgba(0, 0, 0, 0.6)',
                                                      border: 0,
                                                      borderRadius: '50%',
                                                      cursor: 'pointer',
                                                      display: 'none',
                                                      height: '138.359px',
                                                      left: '50%',
                                                      margin: 0,
                                                      padding: 0,
                                                      pointerEvents: 'auto',
                                                      position: 'absolute',
                                                      opacity: 0,
                                                      outline: 'none',
                                                      top: '50%',
                                                      transform: 'translate(-50%, -50%) scale(0.8)',
                                                      transition:
                                                        'opacity 200ms ease 0s, transform 600ms ease 0s',
                                                      width: '138.359px',
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        boxSizing: 'border-box',
                                                        height: '100%',
                                                        padding:
                                                          '46.6963px 46.6963px 46.6963px 57.0732px',
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          height: '100%',
                                                          width: '100%',
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: 'none',
                                                            height: '100%',
                                                            width: '100%',
                                                          }}
                                                        >
                                                          <svg
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 11.556 16"
                                                            enableBackground="new 0 0 11.556 16"
                                                            aria-hidden="true"
                                                            style={{
                                                              fill: 'rgb(255, 255, 255)',
                                                              height: '100%',
                                                              left: 0,
                                                              strokeWidth: 0,
                                                              top: 0,
                                                              width: '100%',
                                                            }}
                                                            className="w-css-reset w-css-reset-tree"
                                                          >
                                                            <g>
                                                              <rect
                                                                x={0}
                                                                y={0}
                                                                width="3.5"
                                                                height={12}
                                                              />
                                                              <rect
                                                                x="6.5"
                                                                y={0}
                                                                width="3.5"
                                                                height={12}
                                                              />
                                                            </g>
                                                          </svg>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display: 'block',
                                                            height: '100%',
                                                            width: '100%',
                                                          }}
                                                        >
                                                          <svg
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 11.556 16"
                                                            enableBackground="new 0 0 11.556 16"
                                                            aria-hidden="true"
                                                            style={{
                                                              fill: 'rgb(255, 255, 255)',
                                                              height: '100%',
                                                              left: 0,
                                                              strokeWidth: 0,
                                                              top: 0,
                                                              width: '100%',
                                                            }}
                                                            className="w-css-reset w-css-reset-tree"
                                                          >
                                                            <polygon points="11.556,7.5 0,15 0,0" />
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="w-vulcan-overlays--right w-css-reset"
                                            style={{
                                              display: 'table-cell',
                                              verticalAlign: 'top',
                                              position: 'relative',
                                              width: 0,
                                            }}
                                          >
                                            <div
                                              style={{ height: '321.783px' }}
                                              className="w-css-reset"
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="w-bottom-bar w-css-reset"
                                          style={{
                                            bottom: 0,
                                            borderCollapse: 'collapse',
                                            display: 'table',
                                            height: 34,
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            right: 0,
                                            tableLayout: 'auto',
                                            width: '100%',
                                          }}
                                        >
                                          <div
                                            className="w-bottom-bar-lower w-css-reset"
                                            style={{ position: 'relative' }}
                                          >
                                            <div
                                              style={{
                                                height: '100%',
                                                left: 0,
                                                position: 'absolute',
                                                top: 0,
                                                width: '100%',
                                              }}
                                            >
                                              <div
                                                style={{
                                                  background: 'rgb(84, 187, 255)',
                                                  display: 'none',
                                                  height: '100%',
                                                  mixBlendMode: 'darken',
                                                  left: 0,
                                                  opacity: 1,
                                                  position: 'absolute',
                                                  top: 0,
                                                  transition: 'opacity 0s ease 0s',
                                                  width: '100%',
                                                }}
                                              />
                                              <div
                                                style={{
                                                  background: 'rgba(84, 187, 255, 0.85)',
                                                  height: '100%',
                                                  opacity: 1,
                                                  left: 0,
                                                  position: 'absolute',
                                                  top: 0,
                                                  transition: 'opacity 0s ease 0s',
                                                  width: '100%',
                                                }}
                                              />
                                            </div>
                                            <div style={{ display: 'none' }}>
                                              <div
                                                style={{
                                                  background: 'rgb(84, 187, 255)',
                                                  display: 'none',
                                                  height: '100%',
                                                  mixBlendMode: 'darken',
                                                  left: 0,
                                                  opacity: 1,
                                                  position: 'absolute',
                                                  top: 0,
                                                  transition: 'opacity 0s ease 0s',
                                                  width: '100%',
                                                }}
                                              />
                                              <div
                                                style={{
                                                  background: 'rgba(84, 187, 255, 0.85)',
                                                  height: '100%',
                                                  opacity: 1,
                                                  left: 0,
                                                  position: 'absolute',
                                                  top: 0,
                                                  transition: 'opacity 0s ease 0s',
                                                  width: '100%',
                                                }}
                                              />
                                            </div>
                                            <div
                                              className="w-bottom-bar-left w-css-reset"
                                              style={{
                                                display: 'table-cell',
                                                verticalAlign: 'top',
                                                position: 'relative',
                                                width: 0,
                                                opacity: 1,
                                                transition: 'opacity 0s ease 0s',
                                              }}
                                            >
                                              <div
                                                className="w-bottom-bar-left-inner w-css-reset"
                                                style={{
                                                  height: 34,
                                                  position: 'relative',
                                                  pointerEvents: 'auto',
                                                  whiteSpace: 'nowrap',
                                                }}
                                              >
                                                <div
                                                  className="w-css-reset"
                                                  style={{
                                                    display: 'inline-block',
                                                    verticalAlign: 'top',
                                                  }}
                                                  data-handle="smallPlayButton"
                                                >
                                                  <div
                                                    className="w-vulcan-button-wrapper w-css-reset"
                                                    style={{
                                                      display: 'inline-block',
                                                      height: 34,
                                                      position: 'relative',
                                                      verticalAlign: 'top',
                                                      width: '39.5313px',
                                                    }}
                                                  >
                                                    <button
                                                      className="w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important"
                                                      style={{
                                                        backgroundColor: 'rgba(0, 0, 0, 0)',
                                                        boxShadow: 'none',
                                                        cursor: 'pointer',
                                                        height: '100%',
                                                        position: 'relative',
                                                        transition:
                                                          'background-color 150ms ease 0s',
                                                        width: '100%',
                                                      }}
                                                      tabIndex={0}
                                                      aria-label="Play Video"
                                                      title="Play Video"
                                                    >
                                                      <div
                                                        className="w-vulcan-icon-wrapper"
                                                        style={{
                                                          boxSizing: 'border-box',
                                                          height: '100%',
                                                          position: 'relative',
                                                          opacity: 1,
                                                          transform: 'scale(1.001)',
                                                          transition: 'transform 200ms ease 0s',
                                                        }}
                                                        data-handle="smallPlayButton_icon_wrapper"
                                                      >
                                                        <div
                                                          style={{
                                                            boxSizing: 'border-box',
                                                            height: '100%',
                                                            marginLeft: '0.988281px',
                                                            padding: '9.88281px 0px 8.89453px',
                                                            position: 'relative',
                                                            width: '100%',
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              height: '100%',
                                                              width: '100%',
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                display: 'none',
                                                                height: '100%',
                                                                width: '100%',
                                                              }}
                                                            >
                                                              <svg
                                                                x="0px"
                                                                y="0px"
                                                                viewBox="0 0 11.556 16"
                                                                enableBackground="new 0 0 11.556 16"
                                                                aria-hidden="true"
                                                                style={{
                                                                  fill: 'rgb(255, 255, 255)',
                                                                  height: '100%',
                                                                  left: 0,
                                                                  strokeWidth: 0,
                                                                  top: 0,
                                                                  width: '100%',
                                                                  verticalAlign: 'top',
                                                                }}
                                                                className="w-css-reset w-css-reset-tree"
                                                              >
                                                                <g>
                                                                  <rect
                                                                    x={0}
                                                                    y={0}
                                                                    width="3.5"
                                                                    height={12}
                                                                  />
                                                                  <rect
                                                                    x="6.5"
                                                                    y={0}
                                                                    width="3.5"
                                                                    height={12}
                                                                  />
                                                                </g>
                                                              </svg>
                                                            </div>
                                                            <div
                                                              style={{
                                                                display: 'block',
                                                                height: '100%',
                                                                width: '100%',
                                                              }}
                                                            >
                                                              <svg
                                                                x="0px"
                                                                y="0px"
                                                                viewBox="0 0 11.556 16"
                                                                enableBackground="new 0 0 11.556 16"
                                                                aria-hidden="true"
                                                                style={{
                                                                  fill: 'rgb(255, 255, 255)',
                                                                  height: '100%',
                                                                  left: 0,
                                                                  strokeWidth: 0,
                                                                  top: 0,
                                                                  width: '100%',
                                                                  verticalAlign: 'top',
                                                                }}
                                                                className="w-css-reset w-css-reset-tree"
                                                              >
                                                                <polygon points="11.556,7.5 0,15 0,0" />
                                                              </svg>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="w-bottom-bar-middle w-css-reset"
                                              style={{
                                                display: 'table-cell',
                                                verticalAlign: 'top',
                                                position: 'relative',
                                                width: '100%',
                                                opacity: 1,
                                                transition: 'opacity 0s ease 0s',
                                              }}
                                            >
                                              <div
                                                className="w-bottom-bar-middle-inner w-css-reset"
                                                style={{
                                                  height: 34,
                                                  position: 'relative',
                                                  pointerEvents: 'auto',
                                                  whiteSpace: 'nowrap',
                                                  opacity: 1,
                                                  transform: 'translateY(0px)',
                                                  transition:
                                                    'opacity 0ms ease 0s, transform 0ms ease 0s',
                                                }}
                                              >
                                                <div
                                                  className="w-css-reset"
                                                  style={{
                                                    height: '100%',
                                                    position: 'relative',
                                                  }}
                                                  data-handle="playbar"
                                                >
                                                  <div
                                                    className="w-playbar-wrapper w-css-reset w-css-reset-tree"
                                                    style={{
                                                      display: 'flex',
                                                      height: '100%',
                                                      width: '100%',
                                                    }}
                                                  >
                                                    <div
                                                      className="w-playbar__time"
                                                      style={{
                                                        boxSizing: 'content-box',
                                                        color: 'white',
                                                        fontFamily:
                                                          'WistiaPlayerInterNumbersSemiBold, Helvetica, sans-serif',
                                                        fontSize: '12.8477px',
                                                        letterSpacing: '0.494141px',
                                                        lineHeight: 34,
                                                        paddingLeft: '4.94141px',
                                                        pointerEvents: 'none',
                                                        position: 'relative',
                                                        textAlign: 'center',
                                                        width: '27.6719px',
                                                      }}
                                                    >
                                                      6:09
                                                    </div>
                                                    <div
                                                      aria-label="Playbar"
                                                      aria-orientation="horizontal"
                                                      aria-valuemax="368.969"
                                                      aria-valuemin={0}
                                                      aria-valuenow={0}
                                                      aria-valuetext="0:00"
                                                      role="slider"
                                                      style={{
                                                        cursor: 'pointer',
                                                        flex: '1 1 0%',
                                                        height: 34,
                                                        outline: 'none',
                                                        marginLeft: '14.8242px',
                                                        marginRight: '9.88281px',
                                                        position: 'relative',
                                                      }}
                                                      tabIndex={0}
                                                    >
                                                      <canvas
                                                        height={34}
                                                        style={{
                                                          height: 34,
                                                          left: '-14.8242px',
                                                          position: 'absolute',
                                                          top: 0,
                                                          width: '441.762px',
                                                        }}
                                                        width={441}
                                                      />
                                                      <div
                                                        style={{
                                                          borderRadius: '50%',
                                                          height: '11.0688px',
                                                          left: '-5.53438px',
                                                          opacity: 0,
                                                          position: 'absolute',
                                                          top: '11.4656px',
                                                          width: '11.0688px',
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="w-bottom-bar-right w-css-reset"
                                              style={{
                                                display: 'table-cell',
                                                verticalAlign: 'top',
                                                position: 'relative',
                                                width: 0,
                                                opacity: 1,
                                                transition: 'opacity 0s ease 0s',
                                                whiteSpace: 'nowrap',
                                              }}
                                            >
                                              <div
                                                className="w-bottom-bar-right-inner-anchor w-css-reset"
                                                style={{
                                                  height: 34,
                                                  position: 'relative',
                                                  pointerEvents: 'auto',
                                                  whiteSpace: 'nowrap',
                                                  display: 'inline-block',
                                                  right: 0,
                                                  top: 0,
                                                  verticalAlign: 'top',
                                                }}
                                              >
                                                <div
                                                  className="w-bottom-bar-right-inner w-css-reset"
                                                  style={{
                                                    height: 34,
                                                    position: 'relative',
                                                    pointerEvents: 'auto',
                                                    whiteSpace: 'nowrap',
                                                    display: 'inline-block',
                                                    opacity: 1,
                                                    right: 0,
                                                    top: 0,
                                                    transform: 'translateY(0px)',
                                                    transition:
                                                      'opacity 0ms ease 0s, transform 0ms ease 0s',
                                                  }}
                                                >
                                                  <div
                                                    className="w-css-reset"
                                                    style={{
                                                      display: 'inline-block',
                                                      verticalAlign: 'top',
                                                    }}
                                                    data-handle="volumeButton"
                                                  >
                                                    <div
                                                      className="w-vulcan-button-wrapper w-css-reset"
                                                      style={{
                                                        display: 'inline-block',
                                                        height: 34,
                                                        position: 'relative',
                                                        verticalAlign: 'top',
                                                        width: '39.5313px',
                                                      }}
                                                    >
                                                      <button
                                                        className="w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important"
                                                        style={{
                                                          backgroundColor: 'rgba(0, 0, 0, 0)',
                                                          boxShadow: 'none',
                                                          cursor: 'pointer',
                                                          height: '100%',
                                                          position: 'relative',
                                                          transition:
                                                            'background-color 150ms ease 0s',
                                                          width: '100%',
                                                        }}
                                                        tabIndex={0}
                                                        aria-label="Mute"
                                                        title="Mute"
                                                      >
                                                        <div
                                                          className="w-vulcan-icon-wrapper"
                                                          style={{
                                                            boxSizing: 'border-box',
                                                            height: '100%',
                                                            position: 'relative',
                                                            opacity: 1,
                                                            transform: 'scale(1.001)',
                                                            transition: 'transform 200ms ease 0s',
                                                          }}
                                                          data-handle="volumeButton_icon_wrapper"
                                                        >
                                                          <svg
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 40 34"
                                                            enableBackground="new 0 0 40 34"
                                                            aria-hidden="true"
                                                            style={{
                                                              fill: 'rgb(255, 255, 255)',
                                                              height: '100%',
                                                              left: 0,
                                                              strokeWidth: 0,
                                                              top: 0,
                                                              width: '100%',
                                                            }}
                                                          >
                                                            <g
                                                              style={{
                                                                transform: 'translateX(1.25px)',
                                                                transition:
                                                                  'transform 100ms ease 0s',
                                                              }}
                                                            >
                                                              <g>
                                                                <path d="M13.8,14.2c-0.5,0.5-1.4,0.8-2,0.8h-1.6C9.5,15,9,15.5,9,16.2v1.6c0,0.7,0.5,1.2,1.2,1.2h1.6c0.7,0,1.6,0.4,2,0.8l2.3,2.3c0.5,0.5,0.8,0.3,0.8-0.4v-9.6c0-0.7-0.4-0.8-0.8-0.4L13.8,14.2z" />
                                                              </g>
                                                              <g>
                                                                <path
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  stroke-line-cap="round"
                                                                  strokeMiterlimit={10}
                                                                  strokeWidth={2}
                                                                  d="M22,11.7c0,0,1.1,2.5,1.1,5s-1.1,5-1.1,5"
                                                                  style={{
                                                                    opacity: 1,
                                                                    transition:
                                                                      'opacity 100ms ease 0s',
                                                                  }}
                                                                />
                                                                <path
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  stroke-line-cap="round"
                                                                  strokeMiterlimit={10}
                                                                  strokeWidth={2}
                                                                  d="M25.8,9.2c0,0,1.7,3.8,1.7,7.5c0,3.7-1.7,7.5-1.7,7.5"
                                                                  style={{
                                                                    opacity: 1,
                                                                    transition:
                                                                      'opacity 100ms ease 0s',
                                                                  }}
                                                                />
                                                              </g>
                                                              <g
                                                                style={{
                                                                  opacity: 0,
                                                                  transition:
                                                                    'opacity 100ms ease 0s',
                                                                }}
                                                              >
                                                                <line
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  stroke-line-cap="round"
                                                                  strokeMiterlimit={10}
                                                                  strokeWidth="1.8102"
                                                                  x1="19.2"
                                                                  y1={15}
                                                                  x2="23.2"
                                                                  y2={19}
                                                                />
                                                                <line
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  stroke-line-cap="round"
                                                                  strokeMiterlimit={10}
                                                                  strokeWidth="1.8102"
                                                                  x1="19.2"
                                                                  y1={19}
                                                                  x2="23.2"
                                                                  y2={15}
                                                                />
                                                              </g>
                                                            </g>
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="w-css-reset"
                                                    style={{
                                                      display: 'inline-block',
                                                      verticalAlign: 'top',
                                                    }}
                                                    data-handle="settingsButton"
                                                  >
                                                    <div
                                                      className="w-vulcan-button-wrapper w-css-reset"
                                                      style={{
                                                        display: 'inline-block',
                                                        height: 34,
                                                        position: 'relative',
                                                        verticalAlign: 'top',
                                                        width: '39.5313px',
                                                      }}
                                                    >
                                                      <button
                                                        className="w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important"
                                                        style={{
                                                          backgroundColor: 'rgba(0, 0, 0, 0)',
                                                          boxShadow: 'none',
                                                          cursor: 'pointer',
                                                          height: '100%',
                                                          position: 'relative',
                                                          transition:
                                                            'background-color 150ms ease 0s',
                                                          width: '100%',
                                                        }}
                                                        tabIndex={0}
                                                        aria-expanded="false"
                                                        aria-label="Show settings menu"
                                                        title="Show settings menu"
                                                      >
                                                        <div
                                                          className="w-vulcan-icon-wrapper"
                                                          style={{
                                                            boxSizing: 'border-box',
                                                            height: '100%',
                                                            position: 'relative',
                                                            opacity: 1,
                                                            transform: 'scale(1.001)',
                                                            transition: 'transform 200ms ease 0s',
                                                          }}
                                                          data-handle="settingsButton_icon_wrapper"
                                                        >
                                                          <svg
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 40 34"
                                                            enableBackground="new 0 0 40 34"
                                                            aria-hidden="true"
                                                            style={{
                                                              fill: 'rgb(255, 255, 255)',
                                                              height: '100%',
                                                              left: 0,
                                                              strokeWidth: 0,
                                                              top: 0,
                                                              width: '100%',
                                                            }}
                                                          >
                                                            <g>
                                                              <g>
                                                                <path d="M28.3,16.4h-1.9c-0.4,0-0.8-0.3-0.9-0.7l-0.4-1.1c-0.2-0.3-0.1-0.8,0.2-1.1l1.3-1.3c0.3-0.3,0.3-0.7,0-1l-0.4-0.4c-0.3-0.3-0.7-0.3-1,0l-1.3,1.3c-0.3,0.3-0.8,0.3-1.1,0.1l-1.1-0.5c-0.4-0.1-0.7-0.5-0.7-0.9V9.1c0-0.4-0.3-0.7-0.7-0.7h-0.6c-0.4,0-0.7,0.3-0.7,0.7v1.7c0,0.4-0.3,0.8-0.7,0.9l-1.2,0.5c-0.3,0.2-0.8,0.1-1.1-0.2l-1.2-1.2c-0.3-0.3-0.7-0.3-1,0l-0.4,0.4c-0.3,0.3-0.3,0.7,0,1l1.2,1.2c0.3,0.3,0.3,0.8,0.1,1.1l-0.5,1.2c-0.1,0.4-0.5,0.7-0.9,0.7h-1.6c-0.4,0-0.7,0.3-0.7,0.7v0.6c0,0.4,0.3,0.7,0.7,0.7h1.6c0.4,0,0.8,0.3,0.9,0.7l0.5,1.2c0.2,0.3,0.1,0.8-0.1,1.1l-1.2,1.2c-0.3,0.3-0.3,0.7,0,1l0.4,0.4c0.3,0.3,0.7,0.3,1,0l1.2-1.2c0.3-0.3,0.8-0.3,1.1-0.2l1.2,0.5c0.4,0.1,0.7,0.5,0.7,0.9v1.7c0,0.4,0.3,0.7,0.7,0.7h0.6c0.4,0,0.7-0.3,0.7-0.7V24c0-0.4,0.3-0.8,0.7-0.9l1.1-0.5c0.3-0.2,0.8-0.1,1.1,0.1l1.3,1.3c0.3,0.3,0.7,0.3,1,0l0.4-0.4c0.3-0.3,0.3-0.7,0-1l-1.3-1.3C25,21,25,20.5,25.1,20.2l0.4-1.1c0.1-0.4,0.5-0.7,0.9-0.7h1.9c0.4,0,0.7-0.3,0.7-0.7v-0.6C29,16.7,28.7,16.4,28.3,16.4z M23.8,17.5c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9s1.7-3.9,3.9-3.9C22.1,13.6,23.8,15.3,23.8,17.5z" />
                                                              </g>
                                                            </g>
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="w-css-reset"
                                                    style={{
                                                      display: 'inline-block',
                                                      verticalAlign: 'top',
                                                    }}
                                                    data-handle="fullscreenControl"
                                                  >
                                                    <div
                                                      className="w-vulcan-button-wrapper w-css-reset"
                                                      style={{
                                                        display: 'inline-block',
                                                        height: 34,
                                                        position: 'relative',
                                                        verticalAlign: 'top',
                                                        width: '39.5313px',
                                                      }}
                                                    >
                                                      <button
                                                        className="w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important"
                                                        style={{
                                                          backgroundColor: 'rgba(0, 0, 0, 0)',
                                                          boxShadow: 'none',
                                                          cursor: 'pointer',
                                                          height: '100%',
                                                          position: 'relative',
                                                          transition:
                                                            'background-color 150ms ease 0s',
                                                          width: '100%',
                                                        }}
                                                        tabIndex={0}
                                                        aria-label="Fullscreen"
                                                        title="Fullscreen"
                                                      >
                                                        <div
                                                          className="w-vulcan-icon-wrapper"
                                                          style={{
                                                            boxSizing: 'border-box',
                                                            height: '100%',
                                                            position: 'relative',
                                                            opacity: 1,
                                                            transform: 'scale(1.001)',
                                                            transition: 'transform 200ms ease 0s',
                                                          }}
                                                          data-handle="fullscreenControl_icon_wrapper"
                                                        >
                                                          <svg
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 40 34"
                                                            enableBackground="new 0 0 40 34"
                                                            aria-hidden="true"
                                                            style={{
                                                              fill: 'rgb(255, 255, 255)',
                                                              height: '100%',
                                                              left: 0,
                                                              strokeWidth: 0,
                                                              top: 0,
                                                              width: '100%',
                                                            }}
                                                          >
                                                            <g>
                                                              <g>
                                                                <polyline
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  strokeWidth={2}
                                                                  strokeLinecap="round"
                                                                  strokeLinejoin="round"
                                                                  strokeMiterlimit={10}
                                                                  points="31.4,12.6 31.4,8.7 25.8,8.7"
                                                                />
                                                                <polyline
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  strokeWidth={2}
                                                                  strokeLinecap="round"
                                                                  strokeLinejoin="round"
                                                                  strokeMiterlimit={10}
                                                                  points="14.7,8.7 9.1,8.7 9.1,12.6"
                                                                />
                                                                <polyline
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  strokeWidth={2}
                                                                  strokeLinecap="round"
                                                                  strokeLinejoin="round"
                                                                  strokeMiterlimit={10}
                                                                  points="25.8,24.8 31.4,24.8 31.4,20.9"
                                                                />
                                                                <polyline
                                                                  fill="none"
                                                                  stroke="#ffffff"
                                                                  strokeWidth={2}
                                                                  strokeLinecap="round"
                                                                  strokeLinejoin="round"
                                                                  strokeMiterlimit={10}
                                                                  points="9.1,20.9 9.1,24.8 14.7,24.8"
                                                                />
                                                              </g>
                                                              <rect
                                                                x="13.7"
                                                                y="12.3"
                                                                fill="none"
                                                                stroke="#ffffff"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeMiterlimit={10}
                                                                enableBackground="new"
                                                                width="13.3"
                                                                height="8.9"
                                                              />
                                                            </g>
                                                          </svg>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="w-ellipsis w-css-reset"
                                                style={{
                                                  height: 34,
                                                  position: 'relative',
                                                  pointerEvents: 'auto',
                                                  whiteSpace: 'nowrap',
                                                  display: 'none',
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="w-foreground w-css-reset"
                                          style={{
                                            height: '100%',
                                            left: 0,
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            top: 0,
                                            width: '100%',
                                          }}
                                        >
                                          <div
                                            className="w-css-reset"
                                            style={{ pointerEvents: 'auto' }}
                                            data-handle="contextMenu"
                                          />
                                          <div
                                            className="w-css-reset"
                                            style={{ pointerEvents: 'auto' }}
                                            data-handle="loadingHourglass"
                                          />
                                          <div
                                            className="w-css-reset"
                                            style={{ pointerEvents: 'auto' }}
                                            data-handle="focusOutline"
                                          >
                                            <div
                                              style={{
                                                boxShadow:
                                                  'rgb(255, 255, 255) 0px 0px 0px 2px inset',
                                                display: 'none',
                                                height: '100%',
                                                left: 0,
                                                pointerEvents: 'none',
                                                position: 'absolute',
                                                right: 0,
                                                width: '100%',
                                              }}
                                              className="w-focus-outline"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <style
                                        id="wistia_63_style"
                                        type="text/css"
                                        className="wistia_injected_style"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            '\n      #wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset{font-size:14px;}\n#wistia_chrome_37 #wistia_grid_57_wrapper div.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper span.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper ul.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper li.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper label.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper fieldset.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper button.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper img.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper a.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper svg.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper p.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper a.w-css-reset{border:0;}\n#wistia_chrome_37 #wistia_grid_57_wrapper h1.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:2em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper h2.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.5em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper h3.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.17em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper p.w-css-reset{margin:1.4em 0;}\n#wistia_chrome_37 #wistia_grid_57_wrapper a.w-css-reset{display:inline;}\n#wistia_chrome_37 #wistia_grid_57_wrapper span.w-css-reset{display:inline;}\n#wistia_chrome_37 #wistia_grid_57_wrapper svg.w-css-reset{display:inline;}\n#wistia_chrome_37 #wistia_grid_57_wrapper ul.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper ol.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper li.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper ul:before.w-css-reset{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper ol:before.w-css-reset{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper li:before.w-css-reset{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper ul:after.w-css-reset{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper ol:after.w-css-reset{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper li:after.w-css-reset{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper label.w-css-reset{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;float:none;outline:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper button.w-css-reset{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;border:0;border-radius:0;outline:none;position:static}\n#wistia_chrome_37 #wistia_grid_57_wrapper img.w-css-reset{border:0;display:inline-block;vertical-align:top;border-radius:0;outline:none;position:static}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset button::-moz-focus-inner{border: 0;}\n      #wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree {font-size:14px;}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree div{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree span{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree ul{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree li{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree label{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree fieldset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree button{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree img{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree a{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree svg{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree p{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree a{border:0;}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree h1{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:2em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree h2{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.5em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree h3{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.17em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree p{margin:1.4em 0;}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree a{display:inline;}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree span{display:inline;}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree svg{display:inline;}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree ul{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree ol{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree li{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree ul:before{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree ol:before{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree li:before{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree ul:after{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree ol:after{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree li:after{display:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree label{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;float:none;outline:none}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree button{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;border:0;border-radius:0;outline:none;position:static}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree img{border:0;display:inline-block;vertical-align:top;border-radius:0;outline:none;position:static}\n#wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-tree  button::-moz-focus-inner{border: 0;}\n      #wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-max-width-none-important{max-width:none!important}\n      #wistia_chrome_37 #wistia_grid_57_wrapper .w-css-reset-button-important{border-radius:0!important;color:#fff!important;}\n    ',
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div id="wistia_grid_57_front" />
                                  <div id="wistia_grid_57_top_inside">
                                    <div
                                      id="wistia_grid_57_top"
                                      style={{
                                        height: 0,
                                        fontSize: 0,
                                        lineHeight: 0,
                                      }}
                                    >
                                      {' '}
                                    </div>
                                  </div>
                                  <div id="wistia_grid_57_bottom_inside">
                                    <div
                                      id="wistia_grid_57_bottom"
                                      style={{
                                        height: 0,
                                        fontSize: 0,
                                        lineHeight: 0,
                                      }}
                                    >
                                      {' '}
                                    </div>
                                  </div>
                                  <div id="wistia_grid_57_left_inside">
                                    <div
                                      id="wistia_grid_57_left"
                                      style={{
                                        height: 0,
                                        fontSize: 0,
                                        lineHeight: 0,
                                      }}
                                    >
                                      {' '}
                                    </div>
                                  </div>
                                  <div id="wistia_grid_57_right_inside">
                                    <div
                                      id="wistia_grid_57_right"
                                      style={{
                                        height: 0,
                                        fontSize: 0,
                                        lineHeight: 0,
                                      }}
                                    >
                                      {' '}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  id="wistia_grid_57_below"
                                  style={{ height: 0, fontSize: 0, lineHeight: 0 }}
                                >
                                  {' '}
                                </div>
                                <style
                                  id="wistia_58_style"
                                  type="text/css"
                                  className="wistia_injected_style"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      '#wistia_grid_57_wrapper{-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box;font-family:Arial,sans-serif;font-size:14px;height:100%;position:relative;text-align:left;width:100%;}\n#wistia_grid_57_wrapper *{-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box;}\n#wistia_grid_57_above{position:relative;}\n#wistia_grid_57_main{display:block;height:100%;position:relative;}\n#wistia_grid_57_behind{height:100%;left:0;position:absolute;top:0;width:100%;}\n#wistia_grid_57_center{height:100%;overflow:hidden;position:relative;width:100%;}\n#wistia_grid_57_front{display:none;height:100%;left:0;position:absolute;top:0;width:100%;}\n#wistia_grid_57_top_inside{position:absolute;left:0;top:0;width:100%;}\n#wistia_grid_57_top{width:100%;position:absolute;bottom:0;left:0;}\n#wistia_grid_57_bottom_inside{position:absolute;left:0;bottom:0;width:100%;}\n#wistia_grid_57_bottom{width:100%;position:absolute;top:0;left:0;}\n#wistia_grid_57_left_inside{height:100%;position:absolute;left:0;top:0;}\n#wistia_grid_57_left{height:100%;position:absolute;right:0;top:0;}\n#wistia_grid_57_right_inside{height:100%;right:0;position:absolute;top:0;}\n#wistia_grid_57_right{height:100%;left:0;position:absolute;top:0;}\n#wistia_grid_57_below{position:relative;}',
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-46903-147"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    aria-disabled="false"
                    data-google-font="Roboto"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_14"
                      data-bold="inherit"
                      style={{
                        textAlign: 'center',
                        fontSize: 20,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      The life you want, the business you want,{' '}
                      <b>
                        and the success you desire will all be possible when you have a predictable
                        listings system….
                      </b>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-119-117"
                className="innerContent col_right ui-resizable col-md-5"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-47179-121"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    aria-disabled="false"
                    data-google-font="Roboto"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{
                        textAlign: 'center',
                        fontSize: 22,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b style={{ fontStyle: 'italic' }}>The One Book Away Challenge </b>
                      includes all my best listing tools and strategies.
                    </div>
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-41663-118"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/02/cd2803904b46c79fc36f8dfdbdf703/ProductImage.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-38310-111"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 10,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    aria-disabled="false"
                    data-google-font="Roboto"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{
                        textAlign: 'center',
                        fontSize: 24,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Join The Challenge Now For A One-Time Discounted Payment Of Only $10</b>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_button-84657-185"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-element-theme="customized"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonPadding2 elBtnVP_10 elBtnHP_25 elButtonTxtColor1 elButtonShadowFlatHighlight elButtonNoShadow elButtonFull elButtonCorner5 elBTN_b_3 mfs_22"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        background: 'rgb(172, 19, 42)',
                        fontSize: 32,
                      }}
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The Challenge Now</span>
                      <span className="elButtonSub" style={{ fontSize: 12 }}>
                        $10 for the first 30 days, then $199 a month. Cancel anytime.
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container wideContainer noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 bgNoRepeat emptySection shadow0"
          id="section--14175"
          data-title="Section"
          data-block-color="0074C7"
          style={{
            paddingTop: 30,
            paddingBottom: 50,
            outline: 'none',
            marginTop: 50,
          }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable" style={{ paddingLeft: 50, paddingRight: 50 }}>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-171"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{ paddingTop: 0, paddingBottom: 20, margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-160-180"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-46170-121"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>
                        The <u>Listing Business You</u> Want Is Just One Book Away
                      </b>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-111"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{ padding: 0, margin: '20px 0px 0px', outline: 'none' }}
            >
              <div
                id="col-left-128-178"
                className="innerContent col_left ui-resizable col-md-7"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-10188-160"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      From the desk of Charles Curry<div>Atlantic Beach, Florida</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        What does <b>“One Book Away”</b> mean?
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>For everyone, it’s different…</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        You might be <u>tired of having to constantly sell clients</u> on why they
                        should work with you, so{' '}
                        <b>you want an automatic way to show them you’re an amazing Realtor.</b>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Or you might have plenty of leads, <u>but you’re stuck</u> without a good
                        system for converting them into listings and clients.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Or perhaps you’re looking for that one listing system that will bring in{' '}
                        <u>consistent listings every single month.</u>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        But before I share my goal for this One Book Away Challenge with you, I have
                        a question…
                      </div>
                      <div>
                        <br />
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-106-108"
                className="innerContent col_right ui-resizable col-md-5"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-68172-118"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/88/c5e5ad5c7742cf87b9738630719d3c/charles-curry.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-127"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                padding: '50px 30px 70px',
                margin: '40px 0px 0px',
                backgroundColor: 'rgb(234, 234, 234)',
                outline: 'none',
              }}
              data-hide-on="mobile"
            >
              <div
                id="col-full-122-150"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-74309-178"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Please Check All of the Options Below That Apply to You:</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_cb_headline1-22253-170"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 40, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to <b>stand out from all of the other agents</b> in your market,
                      but you have <u>NO IDEA</u> idea how to do that?
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-17657-176"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want a <b>steady stream of listings every month</b>, but you’re NOT
                      quite sure how to get lots of them consistently?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-25597-121"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to <b>get more leads automatically</b>, but you don’t have a good
                      automated system for attracting them?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-86182-118"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want <b>more respect from prospective clients</b> and all the other
                      people you work with?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-71960-185"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Are you <b>convinced you need cutting-edge listing strategy</b>s that actually
                      work, but you aren’t sure where to find them?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-66332-166"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to finally reach your listing goals consistently and{' '}
                      <b>build the life of your dreams?</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-175"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone"
              style={{
                padding: '50px 30px 70px',
                margin: '40px 0px 0px',
                backgroundColor: 'rgb(234, 234, 234)',
                outline: 'none',
              }}
              data-hide-on="desktop"
            >
              <div
                id="col-full-122-166-100"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-74309-165-140"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Please Check All of the Options Below That Apply to You:</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_cb_headline1-22253-104-144"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 40, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0 garlic-auto-save"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 26 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to <b>stand out from all of the other agents</b> in your market,
                      but you have <u>NO IDEA</u> idea how to do that?
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-17657-143-148"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0 garlic-auto-save"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 26 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want a <b>steady stream of listings every month</b>, but you’re NOT
                      quite sure how to get lots of them consistently?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-25597-155-115"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0 garlic-auto-save"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 26 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to <b>get more leads automatically</b>, but you don’t have a good
                      automated system for attracting them?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-86182-140-113"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0 garlic-auto-save"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 26 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want <b>more respect from prospective clients</b> and all the other
                      people you work with?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="cb_headline-71960-109-125"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0 garlic-auto-save"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 26 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Are you <b>convinced you need cutting-edge listing strategy</b>s that actually
                      work, but you aren’t sure where to find them?&nbsp;
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="cb_headline-66332-175-109"
                    data-de-type="cb_headline"
                    data-de-editing="false"
                    data-title="checkbox headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-cb-required="yes"
                    data-field-name=""
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <input
                      className="elInput elHeadlineCheckbox required0 garlic-auto-save"
                      type="checkbox"
                      name="custom_type"
                      data-type="extra"
                      data-custom-type="accepted_terms"
                      defaultValue="false"
                      data-required="yes"
                      data-eu-only="no"
                      tabIndex={0}
                    />
                    <div
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{ textAlign: 'left', fontSize: 26 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to finally reach your listing goals consistently and{' '}
                      <b>build the life of your dreams?</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-120"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: '30px 0px 0px',
                outline: 'none',
              }}
            >
              <div
                id="col-full-164-127"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-18975-117"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_25"
                      style={{
                        textAlign: 'center',
                        fontSize: 40,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      If You Checked Any Of The Boxes Above, Then I Want To Invite You To Try The '
                      <b>One Book Away</b>' Challenge <u>And Change Your Life Forever!</u>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-43878-142"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>So, Here Is How The Challenge Works…</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-79046-183"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 40,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_25"
                      data-bold="inherit"
                      style={{ textAlign: 'center', fontSize: 30 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The investment to join the challenge is only $10.</b> This covers
                      everything you get during the challenge and all of the training.
                    </div>
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-19856-102"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 40, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/19/f9560f2bc14aa8b5981c8c33dd58cc/dollars.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-77251-156"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_25"
                      data-bold="inherit"
                      style={{ textAlign: 'center', fontSize: 30 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The investment to join the challenge is only $10.</b> This covers
                      everything you get during the challenge and all of the training.
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-42912-184"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>All You Pay Is $10!</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-114"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: '20px 0px 0px',
                outline: 'none',
                backgroundColor: 'rgb(240, 240, 240)',
              }}
            >
              <div
                id="col-left-141-180"
                className="innerContent col_left ui-resizable col-md-4"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-67397-172"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/72/e84e1700334a368deef30e1af4f8b0/april-hunter2.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-152-183"
                className="innerContent col_right ui-resizable col-md-8"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-41435-105"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 20,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'left',
                        fontSize: 36,
                        color: 'rgb(4, 143, 205)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Lisa</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-45654-126"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_25"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 28,
                        backgroundColor: 'rgb(255, 255, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>
                        <i>“I got a $2.8 Million Listing because of my book.</i>
                      </b>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-62213-185"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 5,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>
                        I sent my book to a seller lead and they called me to list. I showed up and
                        it was very easy because they were already sold on hiring me.{' '}
                        <b>
                          <u>In total, I've gotten 5 high-end listings from the books.</u>
                        </b>{' '}
                        The prices were $2.8 Million, $1.8 Million, $1.5&nbsp; Million, a Million,
                        $900k, and $500k."
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-117"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{ paddingTop: 0, paddingBottom: 20, margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-124-154"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-92746-176"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        color: 'rgb(46, 63, 80)',
                        fontSize: 55,
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Then In Exchange For That Tiny $10 Investment, You Get ALL Of This:</b>
                    </h2>
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-61292-125"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/02/cd2803904b46c79fc36f8dfdbdf703/ProductImage.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elCustomJs elMargin0 ui-droppable de-editable"
                    id="tmp_customjs-75755-138"
                    data-de-type="customjs"
                    data-de-editing="false"
                    data-title="Custom JS / HTML"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div className="elCustomJSBg">CUSTOM JAVASCRIPT / HTML</div>
                    <div
                      className="elCustomJS_code"
                      data-custom-js='<ul class="perks">
	<li>10 Printed Books. <span class="price">($129.50 Value)</span></li>
	<li>A 30-Day Trial of the Authorify Digital Membership.</li>
	<li>Two Easy-To-Share Digital Books. <span class="price">($195 Value)</span></li>
	<li>Two Personalized Books for Different Niches. <span class="price">($997 Value)</span></li>
	<li>The Instant Trust Package. <span class="price">($295 Value)</span></li>
	<li>The Easy-Close Listing Presentation. <span class="price">($495 Value)</span></li>
	<li>The 60-Day Follow up Campaign. <span class="price">($295 Value)</span></li>
	<li>The Complete Guide To Finding Unlimited Leads. <span class="price">($97 Value)</span></li>
	<li>Weekly Coaching Calls. <span class="price">($195 Value)</span></li>
	<li>A Lead Capture Site. <span class="price">($29 Value)</span></li>
	<li><span class="bonus">Bonus:</span> Our Extensive Sales & Follow-Up Templates Library. <span class="price">($295 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Expired Rocket Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Fsbo Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Facebook Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Divorce Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Luxury Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Inherited Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Vacant Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Divorce Attorney Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Print Ad Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Tax Lien Listing Funnel. <span class="price">($97 Value)</span></li>
	<li><span class="bonus">Bonus:</span> The Facebook Follow-Up Formula. <span class="price">($97 Value)</span></li>
</ul>'
                      data-displaytype="htmlregular"
                    >
                      <ul className="perks">
                        <li>
                          10 Printed Books. <span className="price">($129.50 Value)</span>
                        </li>
                        <li>A 30-Day Trial of the Authorify Digital Membership.</li>
                        <li>
                          Two Easy-To-Share Digital Books.{' '}
                          <span className="price">($195 Value)</span>
                        </li>
                        <li>
                          Two Personalized Books for Different Niches.{' '}
                          <span className="price">($997 Value)</span>
                        </li>
                        <li>
                          The Instant Trust Package. <span className="price">($295 Value)</span>
                        </li>
                        <li>
                          The Easy-Close Listing Presentation.{' '}
                          <span className="price">($495 Value)</span>
                        </li>
                        <li>
                          The 60-Day Follow up Campaign. <span className="price">($295 Value)</span>
                        </li>
                        <li>
                          The Complete Guide To Finding Unlimited Leads.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          Weekly Coaching Calls. <span className="price">($195 Value)</span>
                        </li>
                        <li>
                          A Lead Capture Site. <span className="price">($29 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> Our Extensive Sales &amp; Follow-Up
                          Templates Library. <span className="price">($295 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Expired Rocket Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Fsbo Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Facebook Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Divorce Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Luxury Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Inherited Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Vacant Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Divorce Attorney Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Print Ad Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Tax Lien Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                        <li>
                          <span className="bonus">Bonus:</span> The Facebook Follow-Up Formula.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-27203-103"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_34"
                      style={{
                        textAlign: 'center',
                        fontSize: 70,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Total Value: $4,089.50</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-41652-176"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 20,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center', fontSize: 22 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to build a predictable listings system? Then I’ll take&nbsp;
                      <div>you by the hand and show you exactly how to do it step by step.</div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-46099-168"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_34"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(0, 0, 0)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Do You Accept?</b>
                    </h2>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_button-52094-170"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 30,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elButtonCorner3 elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1 elButtonFull elBTNone elBtnVP_10 mfs_22"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        fontWeight: 600,
                        backgroundColor: 'rgb(172, 19, 42)',
                        fontSize: 56,
                      }}
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The Challenge Now!</span>
                      <span className="elButtonSub mfs_16" style={{ fontSize: 16 }}>
                        I want a Step-By-Step Plan, Weekly Coaching, and the Exact Tools I need to
                        easily get listings!
                      </span>
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-60561"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center' }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>$10 for the first 30 days, then $199 a month. Cancel anytime.</i>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_button-47881"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="button"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-elbuttontype={1}
                    aria-disabled="false"
                  >
                    <a
                      onClick={onCancel}
                      type="button"
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elBtnVP_10 elButtonCorner3 elButtonFluid elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1"
                      style={{
                        color: 'rgb(45, 45, 45)',
                        fontWeight: 600,
                        backgroundColor: 'rgba(136, 136, 136, 0.45)',
                        fontSize: 20,
                      }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <span className="elButtonMain">
                        No, Thank you!
                      </span>
                      <span className="elButtonSub" />
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-67526-134"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Need More Information Before Make Your Decision...?</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-79893-142"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 20,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_25"
                      data-bold="inherit"
                      style={{ textAlign: 'center', fontSize: 30 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Let Me Break Down All The Awesome Stuff You'll Get When You
                      <div>Join The Challenge Today!</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container wideContainer noTopMargin padding20-top padding20-bottom padding40H borderSolid border3px cornersAll radius0 bgNoRepeat borderLight emptySection shadow30"
          id="section--48054"
          data-title="Section"
          data-block-color="0074C7"
          style={{
            paddingTop: 25,
            paddingBottom: 25,
            marginTop: 0,
            outline: 'none',
            borderColor: 'rgb(172, 19, 42)',
            backgroundColor: 'rgb(255, 255, 255)',
          }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable" style={{ paddingLeft: 25, paddingRight: 25 }}>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-100"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                padding: '20px 0px',
                margin: 0,
                outline: 'none',
                backgroundImage:
                  'url("//go.authorify.com/hosted/images/7a/df839ae6994e3dbb36e3837319cdf5/Products-BG.jpg")',
              }}
            >
              <div
                id="col-left-116-173"
                className="innerContent col_left ui-resizable col-md-5"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-91463-162"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/5f/bf5e01deab4d2e925d71bdd8238dbb/Products-02.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-161-118"
                className="innerContent col_right ui-resizable col-md-7"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-18123-151"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_25"
                      style={{
                        textAlign: 'center',
                        fontSize: 28,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The First Thing You’ll Get Access To Is The…</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-61095-118"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 72,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>'One Book Away'</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-24921-109"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 95,
                        color: 'rgb(255, 255, 255)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>CHALLENGE</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-167"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{ padding: '10px 0px 20px', margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-106-184"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-30042-102"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 20,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_20"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 22 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Led by Trainer Charles Curry and <b>The ‘One Book Away’ Consulting Team</b>,
                      this challenge is designed to help you <b>Customize</b> and{' '}
                      <b>
                        <u>LAUNCH</u>
                      </b>{' '}
                      your Personally Branded Real Estate Book in just 30 days…
                      <div>
                        <br />
                        <div>
                          Every week Charles will guide you through one of our “Listing Funnels”.
                          Each one is a complete lead-to-listing marketing system built around your
                          book.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-105"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="3 column row"
              style={{ padding: '20px 10px', margin: 0, outline: 'none' }}
            >
              <div
                id="col-left-108-173"
                className="col-md-4 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-57502-163"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 40,
                        color: 'rgb(45, 45, 45)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Step<b> #1</b>
                    </h1>
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-86620-188"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 10, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/4e/0c8534f73e481798bf4d25b29baa5c/Listings.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-11434-151"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 10,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_20"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 22 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Get Loads Of New Leads</b>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-35377-167"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Each week I will show you how to tap into 2,209,825+ highly motivated sellers
                      without cold calling, door knocking, being tech savvy or spending any of your
                      time getting these leads.
                      <div>
                        <br />
                        <div />
                        <div>
                          The lion’s share of these leads are from niches that most agents don’t
                          even know about.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          Divorcing homeowners, empty nesters, inherited homes, and luxury homes are
                          some of the most popular niches our members get listings from.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          You can finally stop chasing ice-cold difficult prospects and instead
                          focus on closing top-quality deals and spending time with your family.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-center-128-117"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="center"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-37892-186"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 40,
                        color: 'rgb(45, 45, 45)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Step<b> #2</b>
                    </h1>
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-71833-144"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/13/c62ec9b21a4a328679af5a6282ee96/step-2-image.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-20806-122"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_20"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 22 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Instantly Build Trust</b>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-48367-112"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          You’ll discover how you can simultaneously inject massive trust in your
                          high quality leads and wipe out your competition from their minds by using
                          our powerful 6 Piece Instant Trust Package.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          You’ll receive the templates, the training, and your own personally
                          branded home selling tips book so you can build your own Instant Trust
                          Package.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          Once opened, your package will release a floodgate of endorphins in your
                          prospect’s mind, fill them with excitement to read your books, and
                          instantly start seeing you as an expert instead of another real-estate
                          salesperson.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          <br />
                        </div>
                        <div />
                        <div />
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-105-135"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="3rd Column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-19069-159"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 40,
                        color: 'rgb(45, 45, 45)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Step<b> #3</b>
                    </h1>
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-51908-137"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/0d/d3797111c549a586948300dd30c31a/step-3-image.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-23630-189"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 10,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_20"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 22 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Easily Close Appointments</b>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="tmp_paragraph-71366-180"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          I’ll give you the secret presentation our members use to convert
                          appointments into no-brainer, fast &amp; easy-close listings regardless of
                          age, looks or background.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          This is a simple, easy-to-follow presentation that shows the seller you
                          have a proven plan for selling their house and backs it up with Case
                          Studies.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          We have personally tested this presentation on more than 100 different
                          listing appointments, so we know it works.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          Our members report that oftentimes the seller is so impressed by the
                          Instant Trust Package and their book, that they don’t even have to
                          present! They just get the listing.
                        </div>
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-165"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-153-165"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-97616-134"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Here Is Your Mission, should you choose to accept this challenge…</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-15420-131"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 30,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_20"
                      style={{
                        textAlign: 'center',
                        fontSize: 30,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <b>Your challenge is to TAKE ACTION and complete the tasks given&nbsp;</b>
                        <b style={{ fontFamily: 'inherit', fontSize: 30 }}>
                          to you every day for 30 days.
                        </b>
                      </div>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-140"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-175-133"
                className="innerContent col_left ui-resizable col-md-7"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-91023-137"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Yes, it is going to require some work.
                      <div>Yes, it will be challenging at times.</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        But every day, you’ll be moving forward with your business and putting
                        yourself on the track toward winning.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And once you’ve got a predictable listings system that brings in listings
                        consistently, you’ll finally enjoy the real estate business of your dreams.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>My only question for you is…</div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-24037-122"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'left',
                        fontSize: 55,
                        color: 'rgb(0, 0, 0)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Do YOU Have&nbsp;</b>
                      <div>
                        <b>What It Takes?</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="tmp_paragraph-78721-178"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 20,
                        color: 'rgb(0, 0, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>
                        By the time the challenge is over, you will have created an entire A-to-Z
                        Listing System.&nbsp;&nbsp;
                      </b>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-84867-127"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 30,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Not only will you know how to find plenty of listing leads, but you will have
                      implemented a marketing system that brings in listings.
                      <div>
                        <br />
                        <div>
                          And, you’ll be able to use this listing system over and over again to feed
                          listings into your business every single month.
                        </div>
                        <div>
                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-168-139"
                className="innerContent col_right ui-resizable col-md-5"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-76126-102"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/a1/beea9543e14dfea3f68bc2de48cedc/mission-testimonials_1.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-59687-175"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/83/bcabc7597a4406abf3634a0b669a0a/mission-testimonials_2.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-46505-123"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/1b/5d5d8d658f4eb5ab52dd2cf1daa4e0/mission-testimonials_3.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-123"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{ paddingTop: 0, paddingBottom: 0, margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-158-127"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-36490-108"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elButtonCorner3 elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1 elButtonFull elBTNone elBtnVP_10 mfs_22"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        fontWeight: 600,
                        backgroundColor: 'rgb(172, 19, 42)',
                        fontSize: 56,
                      }}
                      id="undefined-704"
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The Challenge Now!</span>
                      <span className="elButtonSub mfs_16" style={{ fontSize: 16 }}>
                        I want a Step-By-Step Plan, Weekly Coaching, and the Exact Tools I need to
                        easily get listings!
                      </span>
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-55477"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center' }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>$10 for the first 30 days, then $199 a month. Cancel anytime.</i>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-99702"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="button"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-elbuttontype={1}
                    aria-disabled="false"
                  >
                    <a
                      onClick={onCancel}
                      type="button"
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elBtnVP_10 elButtonCorner3 elButtonFluid elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1"
                      style={{
                        color: 'rgb(45, 45, 45)',
                        fontWeight: 600,
                        backgroundColor: 'rgba(136, 136, 136, 0.45)',
                        fontSize: 20,
                      }}
                      rel="noopener noreferrer"
                      id="undefined-834"
                      target="_blank"
                    >
                      <span className="elButtonMain">
                        No, Thank you!
                      </span>
                      <span className="elButtonSub" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container wideContainer noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 shadow0 bgNoRepeat emptySection"
          id="section--79267"
          data-title="Section"
          data-block-color="0074C7"
          style={{ paddingTop: 20, paddingBottom: 20, outline: 'none', marginTop: 0 }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable">
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-113"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-100-111"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78517-123"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>
                        Get These Amazing Marketing Tools When You Join The One Book Away Challenge
                        Today…
                      </b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-60359-181"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 30,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>10 Printed Books</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-115"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-183"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-71062-179"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/27/32afd1bfca4a09ade19b4f6d839a58/one-book-away-challenge_10-prints-books.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-123"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-22596-162"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 30,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          These will make you stand out from your competition and make clients
                          “want” to work with you.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        You can bring them on listing presentations, give them to sellers you meet
                        or send them out to your listing leads.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        People don’t throw books away, so these books will be a constant
                        “mini-salesperson” sitting in the seller’s home, gently selling them on
                        listing with you.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-147"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-128-140"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-13697-146"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Two Easy-To-Share Digital Books</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-161"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-119-176"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-22596-101-150"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          You’ll love how easy it is to share these Digital Books with all of your
                          buyer and seller leads.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Listing agents love these books because they make a great Pre-Listing
                        Package. They’re great for converting out-of-town listing leads.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Buyer’s agents love these books because they explain the entire home-buying
                        process to buyers. They demonstrate your expertise with the buyer to build a
                        stronger relationship.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        You can share these books on Social Media, use them to build value with your
                        leads, and show people that you are a Real Estate Expert.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-148-185"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-71062-113-135"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/3e/9c61d5f79b45b9833d358b470c630a/share-digital-book.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-145"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-128-119-113"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-13697-133-118"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Two Personalized Books For Buyers &amp; Sellers</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-103"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-113-159"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-76981-168"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                    data-hide-on="desktop"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/39/666779780e42deaf905181531d6918/Mockup-with-Face---New-Angle-1.png"
                      className="elIMG ximg"
                      alt=""
                      width={300}
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-34011-130"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                    data-hide-on="mobile"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/39/666779780e42deaf905181531d6918/Mockup-with-Face---New-Angle-1.png"
                      className="elIMG ximg"
                      alt=""
                      width={200}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-159-163"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-43346-184"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                    data-hide-on="desktop"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/88/d323235b7b4813aa5708e4a6ab07f3/buyer-book-675x1024-small.png"
                      className="elIMG ximg"
                      alt=""
                      width={300}
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-49809-123"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                    data-hide-on="mobile"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/88/d323235b7b4813aa5708e4a6ab07f3/buyer-book-675x1024-small.png"
                      className="elIMG ximg"
                      alt=""
                      width={200}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-184"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-126-170"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-27881-168"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          These are books that have been customized and personalized to you, with
                          your picture on the cover, your name, contact details, etc.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          You get access to our seller book and buyer book. Each book has loads of
                          different cover options available for you, so you can rest easy knowing
                          that your book will align with your branding and be unique to you.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          We also have an&nbsp;
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            Expired Book, FSBO Book, First-Time Buyer Book, Divorce Book, Vacant
                            Book, Inherited Book, Staging Book, Downsizing Book, Foreclosure Book,
                            Investor Book, and many other book options in our library. Once you join
                            the challenge you'll have an opportunity to get access to more books if
                            you would like to.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-179"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The Instant Trust Package</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-162"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-119-156-139"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-71062-113-110-127"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/58/ab8714c8b84d35b6a386e181ab1156/one-book_Instant-trust-package.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-148-106-113"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-22596-101-176-164"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          The Instant Trust Package immediately shows sellers exactly why you’re
                          different from all other Realtors.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        It includes case studies that demonstrate your expertise, a detailed
                        marketing plan, photo brochuse, and much more.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        All this detailed information will make the seller feel confident that you
                        can sell their house for the most money possible.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        This package makes sellers want to hire you, so you don’t have to “close”
                        them on listing with you.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-174"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-126-101-128"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-165-180"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The Easy-Close Listing Presentation</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-154"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-119-156-110-147"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-22596-101-176-103-150"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          This is a simple, easy-to-follow presentation you can go through with
                          every seller to win more listings.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          The presentation shows the seller you have a proven plan for selling their
                          house and backs it up with generic Case Studies.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          We have personally tested this presentation on over 100 different listing
                          presentations, so we know it works.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-148-106-180-177"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-71062-113-110-163-178"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/e3/75bf0ab42942b1a3c0172f1cb63e86/one-book_easy-closed-listing.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-153"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-126-101-106-147"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-165-153-130"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The 60-Day Follow-Up Campaign</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-101"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-119-156-110-172-123"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-71062-113-110-163-138-173"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/89/023f7829a34d598716e36369dfabce/one-book-away_followup-campaign.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-148-106-180-154-165"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-22596-101-176-103-115-130"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Have you ever lost a listing because you were too busy to follow up? I
                          have! That’s why we created the 60-Day Follow-Up Campaign.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        The campaign makes it easy to follow up to win the listing — even if you’re
                        busy.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        When you use it, you’ll never lose another listing because you forgot to
                        follow up.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-108"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-126-101-106-185-159"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-165-153-114-171"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The Complete Guide To Finding Unlimited Leads</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-166"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-119-156-110-172-120-153"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-22596-101-176-103-115-138-149"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Imagine what your real estate business would be like if you had unlimited
                          seller leads. Would you get more listings? You bet!
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Most agents would be surprised at how many great listing leads are available
                        in their market.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        We’ve used extensive predictive analytics to find the best listing leads for
                        you. Then, we created extensive training on how to get all of these
                        different leads.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And if you don’t have time to research these leads yourself, we’ll show you
                        how to hire an inexpensive freelance assistant to research them for you.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-148-106-180-154-150-110"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-71062-113-110-163-138-112-114"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/6a/d3947d70114603a5b04c3ce6e654ec/one-book-away-the-complete-guide.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-132"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-126-101-106-185-119-157"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-165-153-114-141-119"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Lead Capture Site</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-131"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-119-156-110-172-120-186-105"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-71062-113-110-163-138-112-172-117"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/cc/89cdbdd2f04860aa97bc55319ea6df/one-book-away_lead-capture-site.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-148-106-180-154-150-128-169"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-22596-101-176-103-115-138-157-184"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          You’ll get a Buyer &amp; Seller Lead Capture site you can use to promote
                          your books on social media, via email, and on other online platforms.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        This enables you to put your Lead Generation on autopilot and automatically
                        capture new leads that come in the door.
                      </div>
                      <div>
                        Whenever someone requests a copy of your book, the lead’s info will be sent
                        to you instantly.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And your book will be delivered to them immediately, in an easy-to-read
                        digital format.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-144"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-126-101-106-185-119-111-173"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-165-153-114-141-175-127"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_30"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Weekly Coaching Calls</b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-116"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-172-119-156-110-172-120-186-101-161"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-22596-101-176-103-115-138-157-175-135"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Once a week, we host a live coaching call, where we go in-depth on the
                          best strategies and techniques you can use to get more listings.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>You can attend live, ask questions, and interact with our coaches.</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Every week, you’ll discover a different strategy for getting listings. The
                        calls are interactive, so you can ask questions and get personalized help.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-179-148-106-180-154-150-128-176-167"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-71062-113-110-163-138-112-172-171-127"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/81/21eac09bca4fa09e0252552ce91371/one-book-away_weekly-coach.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-135"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{ paddingTop: 0, paddingBottom: 20, margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-104-186"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-90979-137"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Plus, all of the calls are recorded so you can go back and watch again if
                          you need any help.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And if you really want to perfect a specific listing strategy, I recommend
                        watching the corresponding recorded call in our library that will show you
                        exactly how to implement that strategy.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>But that’s not all….</div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-152"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-100-100-137"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78517-108-173"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <b>
                          You Also Get ALL of These Amazing Bonuses When You Join The One Book Away
                          Challenge Today…&nbsp;
                        </b>
                      </div>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-169"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                padding: '40px 10px',
                margin: '30px auto 0px',
                outline: 'none',
                width: '100%',
                maxWidth: '100%',
              }}
            >
              <div
                id="col-left-159-148"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-54523-187"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/ed/6a2ab0037049d4ac9486f5c770a138/templates-library.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-110"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-128"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #1</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-119"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Our Extensive Templates Library.<b>($97 Value)</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-149"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Do you ever struggle with exactly what to say to a potential client?
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        We’ve solved that problem because we’ve come up with simple letter, email,
                        and text message templates that show you exactly what to say every single
                        time.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>We have the following ready to go for you:</div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elBullet elMargin0 ui-droppable mfs_16 de-editable"
                    id="tmp_list_image-37212-149"
                    data-de-type="listimg"
                    data-de-editing="false"
                    data-title="Image List"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <ul
                      className="ne elBulletList listSize1 listImage32 listBorder0"
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                      style={{ color: 'rgb(172, 19, 42)' }}
                    >
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        <b>Sales </b>Letters <b>Templates</b>
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Email Templates
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Text Message Templates
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Postcard Templates.
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Listing Description Templates.
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Listing Flyer Templates.&nbsp;
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Client Review Templates.
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Newsletter Templates.
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Voicemail Scripts.&nbsp;
                      </li>
                      <li
                        style={{
                          fontSize: 18,
                          backgroundImage:
                            'url("//go.authorify.com/hosted/images/b7/ff0e05c5ac43a58955828aae077fde/red-arrow.png")',
                        }}
                      >
                        Follow-Up Scripts.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-142"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone"
              style={{
                padding: '40px 0px',
                margin: '50px auto 0px',
                outline: 'none',
                width: '96%',
                maxWidth: '100%',
              }}
            >
              <div
                id="col-left-159-143-142"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="tmp_headline1-85563-119-117"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #2</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="tmp_subheadline-32526-162-176"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      The Expired Rocket Funnel.
                      <div>
                        <b>($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-159-100"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          This is a proven funnel we’ve used to dominate the Expireds in our market.
                          When you use it, you’ll never miss out on another Expired Listing
                          Opportunity.&nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-119-180"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-29735-150"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/f5/5e14e65b6f463b9457e38a8e754bb7/obc-the-expired-rocket-funnel.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-181"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '50px 0px 0px',
                outline: 'none',
              }}
            >
              <div
                id="col-left-159-117-126"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-67233-186"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/c2/ed8d5faae240e0b9909c5ca4e32e0f/obc-fsbo-listing.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-143-114"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-171-111"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #3</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-178-117"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      The Instant Trust FSBO Listing Funnel.<b> ($97 Value)</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-143-107"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          This is a proven funnel we’ve used to dominate the Fsbos in our market.
                          This funnel makes it easy to build a relationship with the Fsbo and win
                          the listing.&nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-124"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '50px auto 0px',
                outline: 'none',
                width: '96%',
                maxWidth: '100%',
              }}
            >
              <div
                id="col-left-159-143-122-105"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-119-103-135"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #4</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-162-177-104"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        The Facebook Listing Funnel.<b> ($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-159-135-188"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          We’ll show you exactly how to get leads from Facebook and follow up to win
                          the listing.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-119-113-184"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-29735-151-154"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/f5/de0c9093fa48d382cd6a5ce1c7b5f0/obc-facebook-listing.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-149"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone"
              style={{
                padding: '40px 10px',
                margin: '50px 0px 0px',
                outline: 'none',
              }}
            >
              <div
                id="col-left-159-117-154-168"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-67233-167-143"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/95/aba89179844ac3a8f439feeabff9f3/obc-divorce-listing.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-143-178-153"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-171-154-105"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #5</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-178-155-132"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      The Divorce Listing Funnel.
                      <div>
                        <b>($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-143-159-130"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          In this funnel, we’ll show you exactly how to find the Divorce Listing
                          Leads and win the listings. This process shows you the right (and easy)
                          way to win these listings.&nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-125"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '50px auto 0px',
                outline: 'none',
                width: '96%',
                maxWidth: '100%',
              }}
            >
              <div
                id="col-left-159-143-122-133-127"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-119-103-177-134"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #6</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-162-177-184-114"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>The Luxury Listing Funnel.</div>
                      <div>
                        <b>($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-159-135-113-107"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>For years, we struggled to break into the Luxury Market.</div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        But once we discovered the secret to getting luxury listings, we quickly got
                        a bunch of luxury listings.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        We’ll show you our exact strategy and how you can use it to start getting
                        luxury listings today.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-119-113-183-125"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-29735-151-110-145"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/f0/00e043ca814bd4bc1f93da23eac3aa/obc-luxury-listing.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-188"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '50px 0px 0px',
                outline: 'none',
              }}
            >
              <div
                id="col-left-159-117-154-131-127"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-67233-167-181-155"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/25/da9d0f1d524fd8aeb8123db9b031d4/obc-inherited-listing.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-143-178-162-171"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-171-154-144-158"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #7</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-178-155-157-106"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>The Inherited Listing Funnel.</div>
                      <div>
                        <b>($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-143-159-143-170"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Over a million homes are inherited each year. Most list within 6 months.
                          We’ll show you exactly how to find these homes and win the listing.&nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-157"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '50px auto 0px',
                outline: 'none',
                width: '96%',
                maxWidth: '100%',
              }}
            >
              <div
                id="col-left-159-143-122-133-125-100"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-119-103-177-102-117"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #8</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-162-177-184-167-166"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>The Vacant Listing Funnel.</div>
                      <div>
                        <b>($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-159-135-113-103-182"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Over a million Vacant Homes are listed for sale each year. You’ll get our
                          entire system for landing Vacant Listings.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-119-113-183-145-157"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-29735-151-110-125-120"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/5c/1f3c517f214958a4b6f30d4bd0eb24/obc-vacant-campaign.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-129"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '50px auto 0px',
                outline: 'none',
                width: '96%',
                maxWidth: '100%',
              }}
            >
              <div
                id="col-left-159-117-154-131-180-189"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-67233-167-181-107-164"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/e5/cf3cbccf124b1297f293dedc8c95d9/obc-divorce-attorney-listing.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-143-178-162-150-134"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-171-154-144-143-139"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #9</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-178-155-157-165-125"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>The Divorce Attorney Listing.&nbsp;</div>
                      <div>
                        <b>($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-82362-143-159-143-102-139"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Would you like to build up a consistent stream of Referral Listings? Well,
                          you can with Divorce Attorneys.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        One agent built relationships with Divorce Attorneys and now gets consistent
                        listings every single month.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-107"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '50px auto 0px',
                outline: 'none',
                width: '96%',
                maxWidth: '100%',
              }}
            >
              <div
                id="col-left-159-143-122-133-125-108-182"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-85563-119-103-177-102-108-159"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'left',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Bonus #10</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-32526-162-177-184-167-189-118"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_18"
                      style={{
                        textAlign: 'left',
                        fontSize: 30,
                        color: 'rgb(47, 47, 47)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>The Tax Lien Listing Funnel.</div>
                      <div>
                        <b>($97 Value)</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-82362-159-135-113-103-163-134"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Thousands of homes are sold each year because the owners can’t afford
                          them.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        These are great listings because many of them are high-end and you can list
                        them with no competition. We’ll show you exactly how to do it in this
                        funnel.
                      </div>
                      <div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-186-119-113-183-145-133-146"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-29735-151-110-125-179-142"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/93/da34ee79564d61974e4abba300b86f/obc-tax-lien.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-133"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: '30px 0px 0px',
                outline: 'none',
              }}
            >
              <div
                id="col-full-100-100-155-172"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78517-108-174-155"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <b>
                          You Also Get ALL of These Amazing Bonuses When You Join The One Book Away
                          Challenge Today…&nbsp;
                        </b>
                      </div>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-143"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone"
              style={{
                paddingTop: 40,
                paddingBottom: 40,
                margin: '20px 0px 0px',
                outline: 'none',
                backgroundColor: 'rgb(240, 240, 240)',
              }}
            >
              <div
                id="col-left-141-124-121"
                className="innerContent col_left ui-resizable col-md-3"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-67397-149-147"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/16/7bb05e971b47b09c90ab81a38c58ca/debbie2.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-152-112-185"
                className="innerContent col_right ui-resizable col-md-9"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_headline1-41435-104-103"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h1
                      className="ne elHeadline hsSize3 lh4 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'left',
                        fontSize: 36,
                        color: 'rgb(4, 143, 205)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Debbie</b>
                    </h1>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-45654-145-108"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_25"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 32,
                        backgroundColor: 'rgb(255, 255, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>
                        <i>
                          "I got 4 listings and 3 buyers from giving away my books away at Open
                          Houses.
                        </i>
                      </b>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_paragraph-62213-151-161"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 5,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>
                        Whenever I host an Open House, I offer visitors my buyer and seller books.
                        So far,{' '}
                        <b>
                          <u>
                            I have gotten 4 listings and 3 buyers from this strategy and it’s still
                            bringing in business today.
                          </u>
                        </b>
                        "
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-182"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-155-159"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="tmp_subheadline-84611-186"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 20,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{ textAlign: 'center', fontSize: 30 }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      You’ll Get Immediate Access To The Bonuses The Moment You Join
                      <div>The One Book Away Challenge Today!</div>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-148"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-158-120-106"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-36490-167-188"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elButtonCorner3 elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1 elButtonFull elBTNone elBtnVP_10 mfs_22"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        fontWeight: 600,
                        backgroundColor: 'rgb(172, 19, 42)',
                        fontSize: 56,
                      }}
                      id="undefined-704-738"
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The Challenge Now!</span>
                      <span className="elButtonSub mfs_16" style={{ fontSize: 18 }}>
                        I want a Step-By-Step Plan, Weekly Coaching, and the Exact Tools I need to
                        easily get listings!
                      </span>
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-36392"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center' }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>$10 for the first 30 days, then $199 a month. Cancel anytime.</i>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-27137"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="button"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-elbuttontype={1}
                    aria-disabled="false"
                  >
                    <a
                      onClick={onCancel}
                      type="button"
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elBtnVP_10 elButtonCorner3 elButtonFluid elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1"
                      style={{
                        color: 'rgb(45, 45, 45)',
                        fontWeight: 600,
                        backgroundColor: 'rgba(136, 136, 136, 0.45)',
                        fontSize: 20,
                      }}
                      rel="noopener noreferrer"
                      id="undefined-834-872"
                      target="_blank"
                    >
                      <span className="elButtonMain">
                        No, Thank you!
                      </span>
                      <span className="elButtonSub" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-177"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-163-125"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-89828-151"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/fd/4c404e36af4afaa249cce687582bfc/jim-testimonial.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-55682-103"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/ee/7dbc98b58b4bdb83fca7c3bece700b/mark-testimonial.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-103-133"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-165-153-114-141-175-184-177"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'center',
                        fontSize: 40,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>The One Book Away Challenge Is Different!</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-11761-146"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          The One Book Away Challenge is not just some course you’ll never use…
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>It’s not a theory taught by people who have never landed a listing.</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Instead, it’s based on hard-hitting, actionable strategies that actually
                        work. We’ve used these strategies ourselves to get listings right here in
                        Jacksonville, Florida.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        The One Book Away Challenge will work for you because it combines 3 crucial
                        elements that most courses miss:
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>It combines the right marketing Tools and Strategies…</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        With the Powerful Authority Positioning that differentiates you from all the
                        other agents…
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And Weekly Coaching where you get in-depth breakdowns on how everything
                        works and answers to your questions.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        When you combine these 3 crucial elements together, you’ll discover it’s
                        easy to get listings.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-136"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-156-181"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-79388-127"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/02/cd2803904b46c79fc36f8dfdbdf703/ProductImage.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-159"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-158-120-178-152"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-36490-167-151-107"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elButtonCorner3 elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1 elButtonFull elBTNone elBtnVP_10 mfs_22"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        fontWeight: 600,
                        backgroundColor: 'rgb(172, 19, 42)',
                        fontSize: 56,
                      }}
                      id="undefined-704-738-1134"
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The Challenge Now!</span>
                      <span className="elButtonSub mfs_16" style={{ fontSize: 18 }}>
                        I want a Step-By-Step Plan, Weekly Coaching, and the Exact Tools I need to
                        easily get listings!
                      </span>
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-50452"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center' }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>$10 for the first 30 days, then $199 a month. Cancel anytime.</i>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-68337"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="button"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-elbuttontype={1}
                    aria-disabled="false"
                  >
                    <a
                      onClick={onCancel}
                      type="button"
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elBtnVP_10 elButtonCorner3 elButtonFluid elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1"
                      style={{
                        color: 'rgb(45, 45, 45)',
                        fontWeight: 600,
                        backgroundColor: 'rgba(136, 136, 136, 0.45)',
                        fontSize: 20,
                      }}
                      rel="noopener noreferrer"
                      id="undefined-834-872-647"
                      target="_blank"
                    >
                      <span className="elButtonMain">
                        No, Thank you!
                      </span>
                      <span className="elButtonSub" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-150"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-179-169"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-56811-142"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          As you can see, getting access to the One Book Away Challenge is like
                          having our entire team work with you one on one to build your real estate
                          listing systems.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        The only difference is that you couldn't buy a 1-hour consulting call with
                        me for $10. So to get 30 days with all of us for just $10 is crazy!
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Yet,{' '}
                        <b>
                          you get everything on this page for FREE when you try out the One Book
                          Away Challenge
                        </b>{' '}
                        today!
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        I’m excited to help you build a predictable listings system. Are you ready?{' '}
                        <b>Then it’s time to take action now!</b>
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-168"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: '40px 0px 0px',
                outline: 'none',
              }}
            >
              <div
                id="col-left-163-183-161"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-89828-156-178"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/54/5fdd50815542b5831cb62114457c7b/jesse-testimonial.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-55682-174-185"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/c8/2e27633c1a49b8b66b225d5f43d441/cindy-testimonial.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-49104-123"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/1e/159e81d3b94144847c4b42c08c0f29/jc-testimonial.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
              <div
                id="col-right-103-142-101"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-95493-165-153-114-141-175-184-124-149"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      style={{
                        textAlign: 'center',
                        fontSize: 45,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Warning! This Challenge Is NOT For Everyone! Challenge Is Different!</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-11761-133-135"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          If you want to sign up and watch other people actively take the challenge
                          every day but not take action yourself, then it’s not for you.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Nothing will change in your business if you don’t actually do something.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        <b>But…</b>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        If you’re willing to dive in and start learning these new, cutting-edge
                        listing strategies and implementing them in your business…
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        If you want to discover what it’s like to get prospective clients to respect
                        you and take you seriously…
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        If you need Weekly Coaching and Accountability to make sure you do take
                        action…
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Then I invite you to take the One Book Away Challenge and build a
                        predictable listings system for your business.
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-138"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-100-100-155-141-104"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78517-108-174-128-173"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <b>So, What’s The Catch?</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-56811-156-178"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          I’m offering you this challenge because I know that when you get listings
                          with the books, you’re going to continue using the books and buy more
                          books from Authorify.
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        So, my goal is to make you as successful as possible so you’ll continue
                        buying books from us in the future.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And because this challenge is so effective at helping Realtors get listings
                        successfully, we pay for advertising to bring in customers to this
                        challenge. So, we actually lose money for each person who joins the
                        challenge.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>So, why would I do that?</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Because we have a philosophy at Authorify that if we can’t make you money,
                        then we don’t deserve any of yours.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        That’s why my Number One Goal is to help you get more listings so you’ll
                        choose to reinvest some of that income back into Authorify.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>Does that sound fair?</div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-112"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-100-100-155-141-181-179"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78517-108-174-128-185-155"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 20,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <b>Here’s Why You Need</b>
                      </div>
                      <div>
                        <b>To Take Action Now!&nbsp;</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-56811-156-169-152"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          There is an old Chinese proverb that says,{' '}
                          <b>
                            "The best time to plant a tree was 20 years ago. But, the second best
                            time is NOW!"
                          </b>
                        </div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        That’s why NOW is the best time for you to take the One Book Away Challenge
                        and create your own predictable listings system.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        So, don’t procrastinate because you’ll close this page and forget about it.
                        (You know it's true!😉)
                      </div>
                      <div>
                        <br />
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-179"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone - Clone - Clone"
              style={{ paddingTop: 0, paddingBottom: 20, margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-100-100-155-141-181-168-139"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78517-108-174-128-185-132-151"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <b>Is There A Guarantee?</b>
                      </div>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-189"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="2 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-178-162"
                className="col-md-6 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-31799-117"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>Of course!</div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        You’re protected by a 30-Day 100% Money-Back Guarantee. I guarantee that if
                        you join the challenge, go through the materials, order your books, and take
                        action, by the time the challenge is complete, you’ll have a predictable
                        listings system that brings in listings consistently.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And if for any reason you’re not happy with the training or the books during
                        the first 30 days, just let my team know and we’ll immediately refund your
                        $10 investment.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>Pretty simple.</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        But if you're like most people, this experience will change your real estate
                        business and life.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-108-123"
                className="col-md-6 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="tmp_image-40289-184"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/f0/c37dc2af1b4d149ca3b413fb7490b2/sheri-testimonial.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-67440-134"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/3a/3af7d85650493e9f55a4b3e9f6497a/sharon-testimonial.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-128"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-100-100-155-141-181-168-104-112"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78517-108-174-128-185-132-178-182"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <b>Here’s What To Do Next...</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-63242-106"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_22"
                      data-bold="inherit"
                      style={{ textAlign: 'center', fontSize: 30 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Click the button below right now to sign up and start the challenge.
                        </div>
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-102"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row - Clone - Clone - Clone"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-158-120-178-157-179"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-36490-167-151-157-115"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elButtonCorner3 elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1 elButtonFull elBTNone elBtnVP_10 mfs_22"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        fontWeight: 600,
                        backgroundColor: 'rgb(172, 19, 42)',
                        fontSize: 56,
                      }}
                      id="undefined-704-738-1134-283"
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The Challenge Now!</span>
                      <span className="elButtonSub mfs_16" style={{ fontSize: 18 }}>
                        I want a Step-By-Step Plan, Weekly Coaching, and the Exact Tools I need to
                        easily get listings!
                      </span>
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-33068"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center' }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>$10 for the first 30 days, then $199 a month. Cancel anytime.</i>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-75304"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="button"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-elbuttontype={1}
                    aria-disabled="false"
                  >
                    <a
                      onClick={onCancel}
                      type="button"
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elBtnVP_10 elButtonCorner3 elButtonFluid elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1"
                      style={{
                        color: 'rgb(45, 45, 45)',
                        fontWeight: 600,
                        backgroundColor: 'rgba(136, 136, 136, 0.45)',
                        fontSize: 20,
                      }}
                      rel="noopener noreferrer"
                      id="undefined-834-872-647-794"
                      target="_blank"
                    >
                      <span className="elButtonMain">
                        No, Thank you!
                      </span>
                      <span className="elButtonSub" />
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-74972-148"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 25,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>Sincerely,</div>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>Charles Curry</div>
                      <div>
                        <br />
                      </div>
                      <div>
                        P.S. Just in case you’re one of those people who scrolls to the bottom of
                        the page, here’s the deal.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        <b>
                          <i>
                            When you join the One Book Away Challenge for just $10, I’m going to
                            give you all of my best Listing-Getting Tools and Strategies for just
                            $10.
                          </i>
                        </b>
                      </div>
                      <div>
                        <b>
                          <i>
                            <br />
                          </i>
                        </b>
                      </div>
                      <div>
                        <b>
                          <i>
                            And then I’m going to coach you weekly for 30 days and show you exactly
                            how to create a predictable listings system that brings in listings
                            consistently.
                          </i>
                        </b>
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        And if for some crazy reason you don’t love the challenge, simply email my
                        team anytime in the first 30 days and we’ll immediately refund your $10
                        investment.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        Sound fair? Then click the button above and join the One Book Away Challenge
                        now.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-122"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="Recap"
              style={{ paddingTop: 0, paddingBottom: 20, margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-124-100-141"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-92746-127-142"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-hide-on=""
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(46, 63, 80)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Here’s A Recap Of
                      <div>
                        <b>EVERYTHING You'll Get for FREE</b>
                      </div>
                      <div>
                        <b>When You Accept The ‘One Book Away’ Challenge Today!</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-61292-181-123"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/62/51d80174a64f51aa7c3c7f2306e88c/one-book-away-challenge_v3.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elCustomJs elMargin0 ui-droppable de-editable"
                    id="customjs-27546-138"
                    data-de-type="customjs"
                    data-de-editing="false"
                    data-title="Custom JS / HTML"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div className="elCustomJSBg">CUSTOM JAVASCRIPT / HTML</div>
                    <div
                      className="elCustomJS_code"
                      data-custom-js='<ul class="perks">	<li>10 Printed Books. <span class="price">($129.50 Value)</span></li>	<li>A 30-Day Trial of the Authorify Digital Membership.</li>	<li>Two Easy-To-Share Digital Books. <span class="price">($195 Value)</span></li>	<li>Two Personalized Books for Different Niches. <span class="price">($997 Value)</span></li>	<li>The Instant Trust Package. <span class="price">($295 Value)</span></li>	<li>The Easy-Close Listing Presentation. <span class="price">($495 Value)</span></li>	<li>The 60-Day Follow up Campaign. <span class="price">($295 Value)</span></li>	<li>The Complete Guide To Finding Unlimited Leads. <span class="price">($97 Value)</span></li>	<li>Weekly Coaching Calls. <span class="price">($195 Value)</span></li>	<li>A Lead Capture Site. <span class="price">($29 Value)</span></li>	<li><span class="bonus">Bonus:</span> Our Extensive Sales & Follow-Up Templates Library. <span class="price">($295 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Expired Rocket Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Fsbo Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Facebook Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Divorce Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Luxury Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Inherited Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Vacant Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Divorce Attorney Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Print Ad Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Tax Lien Listing Funnel. <span class="price">($97 Value)</span></li>	<li><span class="bonus">Bonus:</span> The Facebook Follow-Up Formula. <span class="price">($97 Value)</span></li></ul>'
                      data-displaytype="htmlregular"
                    >
                      <ul className="perks">
                        {' '}
                        <li>
                          10 Printed Books. <span className="price">($129.50 Value)</span>
                        </li>{' '}
                        <li>A 30-Day Trial of the Authorify Digital Membership.</li>{' '}
                        <li>
                          Two Easy-To-Share Digital Books.{' '}
                          <span className="price">($195 Value)</span>
                        </li>{' '}
                        <li>
                          Two Personalized Books for Different Niches.{' '}
                          <span className="price">($997 Value)</span>
                        </li>{' '}
                        <li>
                          The Instant Trust Package. <span className="price">($295 Value)</span>
                        </li>{' '}
                        <li>
                          The Easy-Close Listing Presentation.{' '}
                          <span className="price">($495 Value)</span>
                        </li>{' '}
                        <li>
                          The 60-Day Follow up Campaign. <span className="price">($295 Value)</span>
                        </li>{' '}
                        <li>
                          The Complete Guide To Finding Unlimited Leads.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          Weekly Coaching Calls. <span className="price">($195 Value)</span>
                        </li>{' '}
                        <li>
                          A Lead Capture Site. <span className="price">($29 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> Our Extensive Sales &amp; Follow-Up
                          Templates Library. <span className="price">($295 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Expired Rocket Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Fsbo Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Facebook Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Divorce Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Luxury Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Inherited Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Vacant Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Divorce Attorney Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Print Ad Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Tax Lien Listing Funnel.{' '}
                          <span className="price">($97 Value)</span>
                        </li>{' '}
                        <li>
                          <span className="bonus">Bonus:</span> The Facebook Follow-Up Formula.{' '}
                          <span className="price">($97 Value)</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-27203-156-115"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_34"
                      style={{
                        textAlign: 'center',
                        fontSize: 70,
                        color: 'rgb(172, 19, 42)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Total Value: $4,089.50</b>
                    </h2>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-41652-118-112"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 20,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center', fontSize: 22 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Do you want to build a predictable listings system? Then I’ll take&nbsp;
                      <div>you by the hand and show you exactly how to do it step by step.</div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-46099-165-159"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{
                      marginTop: 50,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0 mfs_28"
                      style={{
                        textAlign: 'center',
                        fontSize: 55,
                        color: 'rgb(0, 0, 0)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <b>Do You Accept</b>
                      <div>
                        <b>The Challenge?</b>
                      </div>
                    </h2>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_button-52094-158-103"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 30,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elButtonCorner3 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1 elButtonFull elBTNone elBtnVP_10 elBtnHP_25 mfs_28"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        fontWeight: 600,
                        backgroundColor: 'rgb(172, 19, 42)',
                        fontSize: 48,
                      }}
                      id="undefined-726"
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The One Book Away</span>
                      <span className="elButtonSub mfs_24" style={{ fontSize: 72 }}>
                        For Only $10
                      </span>
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-37979"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center' }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>$10 for the first 30 days, then $199 a month. Cancel anytime.</i>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-18550"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="button"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-elbuttontype={1}
                    aria-disabled="false"
                  >
                    <a
                      onClick={onCancel}
                      type="button"
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elBtnVP_10 elButtonCorner3 elButtonFluid elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1"
                      style={{
                        color: 'rgb(45, 45, 45)',
                        fontWeight: 600,
                        backgroundColor: 'rgba(136, 136, 136, 0.45)',
                        fontSize: 20,
                      }}
                      rel="noopener noreferrer"
                      id="undefined-834-872-647-794-119"
                      target="_blank"
                    >
                      <span className="elButtonMain">
                        No, Thank you!
                      </span>
                      <span className="elButtonSub" />
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-88827-126"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 40,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          Invest $10 today to join the 30-Day One Book Away Challenge. After 30
                          days, you will be rebilled at $199 a month for the Authorify Digital
                          Membership. You can cancel at any time, and you will not be billed again.
                          In addition, you get to keep the 10 printed books and all the bonuses you
                          received just for trying it out.&nbsp;
                        </div>
                      </div>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container fullContainer noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 shadow0 bgNoRepeat emptySection"
          id="section--45930"
          data-title="Section"
          data-block-color="0074C7"
          style={{ paddingTop: 20, paddingBottom: 20, outline: 'none' }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable">
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-106"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="success story"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-144-130"
                className="col-md-4 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-33194-116"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/e0/bc96b2ee5f462b9c010e7224c5ae46/Ed-in-Florida.png"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-67357-102"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"I listed 11 Expireds using the books.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-71783-130"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      I used my books to win 10 divorce listings. In addition, I sold many of the
                      divorcing spouses their next homes — which resulted in about 10 buyer sales.
                      The books opened the door and made it easy to win the listings."
                      <div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-21563-103"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Ed in Connecticut</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-center-178-120"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="center"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-99488-103-126"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/c5/3fb58d5df342a0ab636468c5b8cfc9/Ray.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-39826-124-122"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"I got 5 FSBO listings with my books.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-54717-180-140"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          I dropped my book off at a FSBO and told her,{' '}
                          <i>
                            ‘I see you're selling your property. I have a book on how to get the
                            most amount of money for your home.’
                          </i>{' '}
                          She called me and I listed her house. I used that same strategy to list 4
                          other FSBOs."
                        </div>
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-93675-129-182"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Ray in Illinois</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-140-175"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="3rd Column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-33194-134-130-189-140"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/d9/f7687509df4843b4847e96659bcd4a/Ed2.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-67357-112-113-150-142"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"I listed 11 Expireds using the books.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-71783-172-181-139-172"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      I mail a copy of my book to the Expireds and then review it on the listing
                      appointment. <u>This has enabled me to convert 11 Expireds into listings."</u>
                      <div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-21563-126-150-104-153"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Ed in Connecticut</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container fullContainer noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 shadow0 bgNoRepeat emptySection"
          id="section--39917"
          data-title="Section - Clone"
          data-block-color="0074C7"
          style={{ paddingTop: 20, paddingBottom: 20, outline: 'none' }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable">
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-139"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="3 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-144-152-181"
                className="col-md-4 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-33194-134-177"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/31/d0742347b34f09a4039688282b69be/Sharon.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-67357-112-110"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"9 times out of 10, I get the listing — because of my book.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-71783-172-148"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      I am able to get a lot of for sale by owners by using the books. I go and drop
                      off a package with my book. And I can tell you{' '}
                      <u>nine times out of ten when they do decide to choose a realtor, it's me.</u>
                      "
                      <div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-21563-126-179"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Sharon</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-center-178-165-175"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="center"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable hiddenElementTools de-editable"
                    id="img-40167-162-158"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/e7/b9bc9f66b542b2815cc198f7f6de6a/Cathy.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-13798-130-112"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"My books helped me close 12 transactions over the last year.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-39700-187-180"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      I win more listings with my books! I run Facebook Ads to get seller leads. I
                      found that <u>I get more leads when I offer my book</u> — which lead to
                      listings. Sellers love my book and{' '}
                      <u>I get better results when I bring my book to listing presentations</u>.
                      They love the 80/20 story inside the book. The books helped me close 12
                      transactions over the last 12 months."
                      <div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78151-103-134"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Cathy in Michigan</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-140-182-118"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="3rd Column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-33194-134-130-149"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/47/290b5265544f689c2a4a1f6f017e7e/Michelle.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-67357-112-113-108"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"My book won me the listing within 5 minutes.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-71783-172-181-182"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      I went on a listing presentation. I didn’t know the client and they were
                      nervous about moving.{' '}
                      <u>I gave them my book and the wife immediately said ‘this is our agent</u>.
                      Anybody that knows enough to write a book must be the smartest agent we’ve
                      talked to.’ <b>End of story I got the listing.</b>"
                      <div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-21563-126-150-132"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Michelle in California</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container fullContainer noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 shadow0 bgNoRepeat emptySection"
          id="section--57297"
          data-title="Section - Clone - Clone"
          data-block-color="0074C7"
          style={{ paddingTop: 20, paddingBottom: 20, outline: 'none' }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable">
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-173"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="3 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-144-152-183-168"
                className="col-md-4 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-99488-103-145-134-103"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/7d/b416e1e00748fb97bd215de41b9d28/Ben.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-39826-124-110-118-120"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>
                            "My books help me win Fsbo Listings and have gotten me about 10 listings
                            so far.
                          </b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-54717-180-153-152-140"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      The books help me stand out from all the other agents trying to list Fsbos.
                      <div>
                        <br />
                      </div>
                      <div>
                        For example, I recently got a $500k Fsbo Listing that every agent around was
                        after. He got my book and called me to list.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        I really like the books because they get sellers to fix up and stage their
                        homes.
                      </div>
                      <div>
                        <br />
                      </div>
                      <div>
                        So far the books have helped me get about 10 listings.”
                        <br />
                        <div>
                          <div />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-93675-129-140-141-139"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Ben in Florida</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-center-178-165-104-154"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="center"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-40167-162-131-148"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/c5/e08d0098014e38a6fd4240f34c636d/Jarnell-.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-13798-130-154-121"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"I got million dollar deals from my book.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-39700-187-115-178"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      I gave my book to a listing lead who happened to be a Council Member for a
                      local municipality. I got his listing and sold it.
                      <div>
                        &nbsp;
                        <div>
                          <div />
                          <div />
                        </div>
                        <div />
                        <div>
                          Turns out that local municipality ended up using me for all their real
                          estate needs.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          I’m in meetings with the Mayor and City Attorney and they’re sold on me.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          They love the book and they’re sending me lists of properties they need to
                          sell.”
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78151-103-154-184"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Jarnell in Missouri</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-140-182-101-119"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="3rd Column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-99488-103-145-160"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/76/34df4f8d6e48faa172368eea0ef056/Michael.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable hiddenElementTools de-editable"
                    id="headline-39826-124-110-171"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>"I got 5 FSBO listings with my books.</b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-54717-180-153-189"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      One seller was going to meet with 2 other agents and myself.
                      <div>
                        &nbsp;
                        <div>
                          <div />
                        </div>
                        <div />
                        <div>
                          So, when I met her, I gave her my book. And she said, ‘You know what, I
                          don't need to talk to those other two agents. You're my guy.’ And I won
                          that listing.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          I’ve also had great success advertising my book in the local newspaper
                          with an ad that says: ‘Don’t list your home for sale until you’ve read my
                          book.’ It’s worked really well.”
                        </div>
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-93675-129-140-150"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Michael in Nevada</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container fullContainer noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 shadow0 bgNoRepeat emptySection"
          id="section--29746"
          data-title="Section - Clone - Clone - Clone"
          data-block-color="0074C7"
          style={{ paddingTop: 20, paddingBottom: 20, outline: 'none' }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
        >
          <div className="containerInner ui-sortable">
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-118"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="3 column row"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-left-144-152-183-134-144"
                className="col-md-4 innerContent col_left ui-resizable"
                data-col="left"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="tmp_image-99488-144"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/75/a29628fe7c45499986f9ab1399a21f/Mark.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-39826-142"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>
                            "I doubled my close rate on listing presentations after I started using
                            my book.
                          </b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-54717-147"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Before I started using the book, I was averaging about a 45% close rate on
                      listing presentations.
                      <div>
                        &nbsp;
                        <div>
                          <div />
                          <div />
                        </div>
                        <div />
                        <div>
                          Once I started using the book, I’m winning about 90% of my listing
                          appointments. I track my metrics closely, so it’s made a huge difference.
                        </div>
                        <div>
                          <br />
                        </div>
                        <div>
                          I used to work as a Corporate Brand Manager. I love the books because they
                          reinforce my total brand.”
                        </div>
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-93675-133"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Mark in New Jersey</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-center-178-165-104-146-171"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="center"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="2nd column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elImageWrapper de-image-block elAlign_center elMargin0 ui-droppable de-editable"
                    id="img-40167-162-131-147-178"
                    data-de-type="img"
                    data-de-editing="false"
                    data-title="image"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 0, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <img
                      src="//go.authorify.com/hosted/images/b3/41174187974eebb7b98531e939b6f6/Maria.jpg"
                      className="elIMG ximg"
                      alt=""
                      tabIndex={0}
                    />
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-13798-130-154-103-181"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      backgroundColor: 'rgb(255, 227, 0)',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{
                        textAlign: 'left',
                        fontSize: 18,
                        backgroundColor: 'rgb(255, 227, 0)',
                      }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <b>
                            "I followed your system and so far, 2 different sellers have called me
                            to talk about listing with me.
                          </b>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-39700-187-115-185-187"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      One lead came from an Estate Sale. The seller inherited the home and wants to
                      sell it.
                      <div>
                        <br />
                        <div>
                          <div />
                          <div />
                        </div>
                        <div />
                        <div>The other is a Fsbo who liked my approach and is ready to list.</div>
                        <div>
                          <br />
                        </div>
                        <div>
                          I’m looking forward to using my books to win more listings and excited to
                          see what the future holds.”
                        </div>
                        <div />
                      </div>
                    </div>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-78151-103-154-170-114"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 15,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0 mfs_16"
                      data-bold="inherit"
                      style={{ textAlign: 'left', fontSize: 18 }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <div>
                        <div>
                          <span style={{ backgroundColor: 'initial', color: 'inherit' }}>
                            <b>- Maria in Texas</b>
                          </span>
                        </div>
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="col-right-140-182-101-134-148"
                className="col-md-4 innerContent col_right ui-resizable"
                data-col="right"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="3rd Column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                />
              </div>
            </div>
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-160"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="cta-bottom"
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                margin: 0,
                outline: 'none',
              }}
            >
              <div
                id="col-full-175-111"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-75343-113"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="cf-prod-grp-3905587-3906950"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{
                      marginTop: 0,
                      outline: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Roboto, Helvetica, sans-serif !important',
                    }}
                    data-google-font="Roboto"
                    aria-disabled="false"
                    data-elbuttontype={1}
                  >
                    <a
                      href={offerLink}
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elButtonCorner3 elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1 elButtonFull elBTNone elBtnVP_10 mfs_22"
                      style={{
                        color: 'rgb(255, 255, 255)',
                        fontWeight: 600,
                        backgroundColor: 'rgb(172, 19, 42)',
                        fontSize: 56,
                      }}
                      id="undefined-704-738-1164"
                      target="_blank"
                    >
                      <span className="elButtonMain">Join The Challenge Now!</span>
                      <span className="elButtonSub mfs_16" style={{ fontSize: 18 }}>
                        I want a Step-By-Step Plan, Weekly Coaching, and the Exact Tools I need to
                        easily get listings!
                      </span>
                    </a>
                  </div>
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-97486"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="Paragraph"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div
                      className="ne elHeadline hsSize1 lh5 elMargin0 elBGStyle0 hsTextShadow0"
                      data-bold="inherit"
                      style={{ textAlign: 'center' }}
                      data-gramm="false"
                      contentEditable="false"
                    >
                      <i>$10 for the first 30 days, then $199 a month. Cancel anytime.</i>
                    </div>
                  </div>
                  <div
                    className="de elBTN elAlign_center elMargin0 ui-droppable de-editable"
                    id="button-67290"
                    data-de-type="button"
                    data-de-editing="false"
                    data-title="button"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 30, outline: 'none', cursor: 'pointer' }}
                    data-elbuttontype={1}
                    aria-disabled="false"
                  >
                    <a
                      onClick={onCancel}
                      type="button"
                      className="elButton elButtonSize1 elButtonColor1 elButtonRounded elButtonPadding2 elBtnVP_10 elButtonCorner3 elButtonFluid elBtnHP_25 elBTN_b_1 elButtonShadowN1 elButtonTxtColor1"
                      style={{
                        color: 'rgb(45, 45, 45)',
                        fontWeight: 600,
                        backgroundColor: 'rgba(136, 136, 136, 0.45)',
                        fontSize: 20,
                      }}
                      rel="noopener noreferrer"
                      id="undefined-834-872-647-794-119-823"
                      target="_blank"
                    >
                      <span className="elButtonMain">
                        No, Thank you!
                      </span>
                      <span className="elButtonSub" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dropZoneForSections ui-droppable" style={{ display: 'none' }}>
          <div className="dropIconr">
            <i className="fa fa-plus" />
          </div>
        </div>
        <div
          className="container noTopMargin padding20-top padding20-bottom padding40H noBorder borderSolid border3px cornersAll radius0 shadow0 bgNoRepeat emptySection fullContainer"
          id="section--72740"
          data-title="Section"
          data-block-color="0074C7"
          style={{
            paddingTop: 20,
            paddingBottom: 20,
            outline: 'none',
            backgroundColor: 'rgb(46, 63, 80)',
            marginTop: 5,
          }}
          data-trigger="none"
          data-animate="fade"
          data-delay={500}
          data-hide-on=""
        >
          <div className="containerInner ui-sortable">
            <div
              className="row bgCover noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
              id="row-134"
              data-trigger="none"
              data-animate="fade"
              data-delay={500}
              data-title="1 column row"
              style={{ paddingTop: 0, paddingBottom: 0, margin: 0, outline: 'none' }}
            >
              <div
                id="col-full-171-119-139-182-189"
                className="col-md-12 innerContent col_left"
                data-col="full"
                data-trigger="none"
                data-animate="fade"
                data-delay={500}
                data-title="1st column"
                style={{ outline: 'none' }}
              >
                <div
                  className="col-inner bgCover  noBorder borderSolid border3px cornersAll radius0 shadow0 P0-top P0-bottom P0H noTopMargin"
                  style={{ padding: '0 10px' }}
                >
                  <div
                    className="de elHeadlineWrapper ui-droppable de-editable"
                    id="headline-80497-124-109-150"
                    data-de-type="headline"
                    data-de-editing="false"
                    data-title="sub-headline"
                    data-ce="true"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    data-gramm="false"
                    style={{ marginTop: 15, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <h2
                      className="ne elHeadline hsSize2 lh3 elMargin0 elBGStyle0 hsTextShadow0"
                      style={{
                        textAlign: 'center',
                        fontSize: 14,
                        color: 'rgb(132, 146, 166)',
                      }}
                      data-bold="inherit"
                      data-gramm="false"
                      contentEditable="false"
                    >
                      Authorify © 2022 - All Rights Reserved
                      <div>3500 Beachwood Court #203 Jacksonville, FL 32216</div>
                    </h2>
                  </div>
                  <div
                    className="de elCustomJs elMargin0 ui-droppable de-editable"
                    id="tmp_customjs-89290-139-189-147-129"
                    data-de-type="customjs"
                    data-de-editing="false"
                    data-title="Custom JS / HTML"
                    data-ce="false"
                    data-trigger="none"
                    data-animate="fade"
                    data-delay={500}
                    style={{ marginTop: 5, outline: 'none', cursor: 'pointer' }}
                    aria-disabled="false"
                  >
                    <div className="elCustomJSBg">CUSTOM JAVASCRIPT / HTML</div>
                    <div
                      className="elCustomJS_code"
                      data-custom-js='<style>.legal { text-align: center;}.legal span,.legal a {  color: rgb(132, 146, 166); font-size: 13px;}</style><div class="legal">  <a target="_blank" href="https://authorify.com/privacy">Privacy</a>  <span> | </span>  <a target="_blank" href="https://authorify.com/terms">Terms Of Use</a></div>'
                      data-displaytype="htmlregular"
                    >
                      <style
                        dangerouslySetInnerHTML={{
                          __html:
                            '.legal { text-align: center;}.legal span,.legal a {  color: rgb(132, 146, 166); font-size: 13px;}',
                        }}
                      />
                      <div className="legal">
                        {' '}
                        <a target="_blank" href="https://authorify.com/privacy" rel="noreferrer">
                          Privacy
                        </a>{' '}
                        <span> | </span>{' '}
                        <a target="_blank" href="https://authorify.com/terms" rel="noreferrer">
                          Terms Of Use
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpsellContent;
